"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.1
// source: chronik.proto
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastTxRequest = exports.Utxos = exports.ScriptBatchSummaryResponse = exports.ScriptBatchSummaryRow = exports.ScriptBatchSummaryRequest = exports.ScriptBatchSummaryParams = exports.ScriptBatchUtxosResponse = exports.ScriptBatchUtxosRow = exports.ScriptBatchUtxosRequest = exports.ScriptBatchUtxosParams = exports.ScriptRef = exports.ScriptUtxos = exports.TxHistoryPage = exports.PluginGroups = exports.PluginGroup = exports.PluginEntry = exports.TokenFailedColoring = exports.TokenFailedParsing = exports.Token = exports.GenesisInfo = exports.TokenEntry = exports.TokenInfo = exports.TokenType = exports.BlockMetadata = exports.TxOutput_PluginsEntry = exports.TxOutput = exports.TxInput_PluginsEntry = exports.TxInput = exports.SpentBy = exports.OutPoint = exports.Utxo_PluginsEntry = exports.Utxo = exports.ScriptUtxo_PluginsEntry = exports.ScriptUtxo = exports.Tx = exports.BlockInfo = exports.ChronikInfo = exports.BlockchainInfo = exports.BlockHeaders = exports.BlockHeader = exports.Blocks = exports.Block = exports.TxMsgType = exports.TxFinalizationReasonType = exports.BlockMsgType = exports.TokenTxType = exports.SlpTokenType = exports.AlpTokenType = exports.TokenStatus = exports.protobufPackage = void 0;
exports.Error = exports.Empty = exports.MsgTx = exports.TxFinalizationReason = exports.MsgBlock = exports.CoinbaseData = exports.WsMsg = exports.WsSubTxId = exports.WsPlugin = exports.WsSubLokadId = exports.WsSubTokenId = exports.WsSubScript = exports.WsSubTxs = exports.WsSubBlocks = exports.WsSub = exports.RawTx = exports.BroadcastTxsResponse = exports.BroadcastTxsRequest = exports.BroadcastTxResponse = void 0;
exports.tokenStatusFromJSON = tokenStatusFromJSON;
exports.tokenStatusToJSON = tokenStatusToJSON;
exports.alpTokenTypeFromJSON = alpTokenTypeFromJSON;
exports.alpTokenTypeToJSON = alpTokenTypeToJSON;
exports.slpTokenTypeFromJSON = slpTokenTypeFromJSON;
exports.slpTokenTypeToJSON = slpTokenTypeToJSON;
exports.tokenTxTypeFromJSON = tokenTxTypeFromJSON;
exports.tokenTxTypeToJSON = tokenTxTypeToJSON;
exports.blockMsgTypeFromJSON = blockMsgTypeFromJSON;
exports.blockMsgTypeToJSON = blockMsgTypeToJSON;
exports.txFinalizationReasonTypeFromJSON = txFinalizationReasonTypeFromJSON;
exports.txFinalizationReasonTypeToJSON = txFinalizationReasonTypeToJSON;
exports.txMsgTypeFromJSON = txMsgTypeFromJSON;
exports.txMsgTypeToJSON = txMsgTypeToJSON;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = 'chronik';
/** Status of a token tx */
var TokenStatus;
(function (TokenStatus) {
    /**
     * TOKEN_STATUS_NON_TOKEN - Tx involves no tokens whatsover, i.e. neither any burns nor any failed
     * parsing/coloring or any tokens being created / moved.
     */
    TokenStatus[TokenStatus["TOKEN_STATUS_NON_TOKEN"] = 0] = "TOKEN_STATUS_NON_TOKEN";
    /** TOKEN_STATUS_NORMAL - Tx involves tokens but no unintentional burns or failed parsings/colorings */
    TokenStatus[TokenStatus["TOKEN_STATUS_NORMAL"] = 1] = "TOKEN_STATUS_NORMAL";
    /** TOKEN_STATUS_NOT_NORMAL - Tx involves tokens but contains unintentional burns or failed parsings/colorings */
    TokenStatus[TokenStatus["TOKEN_STATUS_NOT_NORMAL"] = 2] = "TOKEN_STATUS_NOT_NORMAL";
    TokenStatus[TokenStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TokenStatus || (exports.TokenStatus = TokenStatus = {}));
function tokenStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'TOKEN_STATUS_NON_TOKEN':
            return TokenStatus.TOKEN_STATUS_NON_TOKEN;
        case 1:
        case 'TOKEN_STATUS_NORMAL':
            return TokenStatus.TOKEN_STATUS_NORMAL;
        case 2:
        case 'TOKEN_STATUS_NOT_NORMAL':
            return TokenStatus.TOKEN_STATUS_NOT_NORMAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TokenStatus.UNRECOGNIZED;
    }
}
function tokenStatusToJSON(object) {
    switch (object) {
        case TokenStatus.TOKEN_STATUS_NON_TOKEN:
            return 'TOKEN_STATUS_NON_TOKEN';
        case TokenStatus.TOKEN_STATUS_NORMAL:
            return 'TOKEN_STATUS_NORMAL';
        case TokenStatus.TOKEN_STATUS_NOT_NORMAL:
            return 'TOKEN_STATUS_NOT_NORMAL';
        case TokenStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
/** ALP token type */
var AlpTokenType;
(function (AlpTokenType) {
    /** ALP_TOKEN_TYPE_STANDARD - Standard ALP token type */
    AlpTokenType[AlpTokenType["ALP_TOKEN_TYPE_STANDARD"] = 0] = "ALP_TOKEN_TYPE_STANDARD";
    AlpTokenType[AlpTokenType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AlpTokenType || (exports.AlpTokenType = AlpTokenType = {}));
function alpTokenTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'ALP_TOKEN_TYPE_STANDARD':
            return AlpTokenType.ALP_TOKEN_TYPE_STANDARD;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AlpTokenType.UNRECOGNIZED;
    }
}
function alpTokenTypeToJSON(object) {
    switch (object) {
        case AlpTokenType.ALP_TOKEN_TYPE_STANDARD:
            return 'ALP_TOKEN_TYPE_STANDARD';
        case AlpTokenType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
/** SLP token type */
var SlpTokenType;
(function (SlpTokenType) {
    /** SLP_TOKEN_TYPE_NONE - Unknown "0" token type */
    SlpTokenType[SlpTokenType["SLP_TOKEN_TYPE_NONE"] = 0] = "SLP_TOKEN_TYPE_NONE";
    /** SLP_TOKEN_TYPE_FUNGIBLE - SLP V1 token type */
    SlpTokenType[SlpTokenType["SLP_TOKEN_TYPE_FUNGIBLE"] = 1] = "SLP_TOKEN_TYPE_FUNGIBLE";
    /** SLP_TOKEN_TYPE_MINT_VAULT - SLP V2 mint vault token type */
    SlpTokenType[SlpTokenType["SLP_TOKEN_TYPE_MINT_VAULT"] = 2] = "SLP_TOKEN_TYPE_MINT_VAULT";
    /** SLP_TOKEN_TYPE_NFT1_GROUP - NFT1 group token type */
    SlpTokenType[SlpTokenType["SLP_TOKEN_TYPE_NFT1_GROUP"] = 129] = "SLP_TOKEN_TYPE_NFT1_GROUP";
    /** SLP_TOKEN_TYPE_NFT1_CHILD - NFT1 child token type */
    SlpTokenType[SlpTokenType["SLP_TOKEN_TYPE_NFT1_CHILD"] = 65] = "SLP_TOKEN_TYPE_NFT1_CHILD";
    SlpTokenType[SlpTokenType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SlpTokenType || (exports.SlpTokenType = SlpTokenType = {}));
function slpTokenTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'SLP_TOKEN_TYPE_NONE':
            return SlpTokenType.SLP_TOKEN_TYPE_NONE;
        case 1:
        case 'SLP_TOKEN_TYPE_FUNGIBLE':
            return SlpTokenType.SLP_TOKEN_TYPE_FUNGIBLE;
        case 2:
        case 'SLP_TOKEN_TYPE_MINT_VAULT':
            return SlpTokenType.SLP_TOKEN_TYPE_MINT_VAULT;
        case 129:
        case 'SLP_TOKEN_TYPE_NFT1_GROUP':
            return SlpTokenType.SLP_TOKEN_TYPE_NFT1_GROUP;
        case 65:
        case 'SLP_TOKEN_TYPE_NFT1_CHILD':
            return SlpTokenType.SLP_TOKEN_TYPE_NFT1_CHILD;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SlpTokenType.UNRECOGNIZED;
    }
}
function slpTokenTypeToJSON(object) {
    switch (object) {
        case SlpTokenType.SLP_TOKEN_TYPE_NONE:
            return 'SLP_TOKEN_TYPE_NONE';
        case SlpTokenType.SLP_TOKEN_TYPE_FUNGIBLE:
            return 'SLP_TOKEN_TYPE_FUNGIBLE';
        case SlpTokenType.SLP_TOKEN_TYPE_MINT_VAULT:
            return 'SLP_TOKEN_TYPE_MINT_VAULT';
        case SlpTokenType.SLP_TOKEN_TYPE_NFT1_GROUP:
            return 'SLP_TOKEN_TYPE_NFT1_GROUP';
        case SlpTokenType.SLP_TOKEN_TYPE_NFT1_CHILD:
            return 'SLP_TOKEN_TYPE_NFT1_CHILD';
        case SlpTokenType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
/** SLP/ALP tx type */
var TokenTxType;
(function (TokenTxType) {
    /** NONE - No tx type, e.g. when input tokens are burned */
    TokenTxType[TokenTxType["NONE"] = 0] = "NONE";
    /** UNKNOWN - Unknown tx type, i.e. for unknown token types */
    TokenTxType[TokenTxType["UNKNOWN"] = 1] = "UNKNOWN";
    /** GENESIS - GENESIS tx */
    TokenTxType[TokenTxType["GENESIS"] = 2] = "GENESIS";
    /** SEND - SEND tx */
    TokenTxType[TokenTxType["SEND"] = 3] = "SEND";
    /** MINT - MINT tx */
    TokenTxType[TokenTxType["MINT"] = 4] = "MINT";
    /** BURN - BURN tx */
    TokenTxType[TokenTxType["BURN"] = 5] = "BURN";
    TokenTxType[TokenTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TokenTxType || (exports.TokenTxType = TokenTxType = {}));
function tokenTxTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'NONE':
            return TokenTxType.NONE;
        case 1:
        case 'UNKNOWN':
            return TokenTxType.UNKNOWN;
        case 2:
        case 'GENESIS':
            return TokenTxType.GENESIS;
        case 3:
        case 'SEND':
            return TokenTxType.SEND;
        case 4:
        case 'MINT':
            return TokenTxType.MINT;
        case 5:
        case 'BURN':
            return TokenTxType.BURN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TokenTxType.UNRECOGNIZED;
    }
}
function tokenTxTypeToJSON(object) {
    switch (object) {
        case TokenTxType.NONE:
            return 'NONE';
        case TokenTxType.UNKNOWN:
            return 'UNKNOWN';
        case TokenTxType.GENESIS:
            return 'GENESIS';
        case TokenTxType.SEND:
            return 'SEND';
        case TokenTxType.MINT:
            return 'MINT';
        case TokenTxType.BURN:
            return 'BURN';
        case TokenTxType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
/** Type of message for the block */
var BlockMsgType;
(function (BlockMsgType) {
    /** BLK_CONNECTED - Block connected to the blockchain */
    BlockMsgType[BlockMsgType["BLK_CONNECTED"] = 0] = "BLK_CONNECTED";
    /** BLK_DISCONNECTED - Block disconnected from the blockchain */
    BlockMsgType[BlockMsgType["BLK_DISCONNECTED"] = 1] = "BLK_DISCONNECTED";
    /** BLK_FINALIZED - Block has been finalized by Avalanche */
    BlockMsgType[BlockMsgType["BLK_FINALIZED"] = 2] = "BLK_FINALIZED";
    /** BLK_INVALIDATED - Block has been invalidated by Avalanche */
    BlockMsgType[BlockMsgType["BLK_INVALIDATED"] = 3] = "BLK_INVALIDATED";
    BlockMsgType[BlockMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BlockMsgType || (exports.BlockMsgType = BlockMsgType = {}));
function blockMsgTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'BLK_CONNECTED':
            return BlockMsgType.BLK_CONNECTED;
        case 1:
        case 'BLK_DISCONNECTED':
            return BlockMsgType.BLK_DISCONNECTED;
        case 2:
        case 'BLK_FINALIZED':
            return BlockMsgType.BLK_FINALIZED;
        case 3:
        case 'BLK_INVALIDATED':
            return BlockMsgType.BLK_INVALIDATED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return BlockMsgType.UNRECOGNIZED;
    }
}
function blockMsgTypeToJSON(object) {
    switch (object) {
        case BlockMsgType.BLK_CONNECTED:
            return 'BLK_CONNECTED';
        case BlockMsgType.BLK_DISCONNECTED:
            return 'BLK_DISCONNECTED';
        case BlockMsgType.BLK_FINALIZED:
            return 'BLK_FINALIZED';
        case BlockMsgType.BLK_INVALIDATED:
            return 'BLK_INVALIDATED';
        case BlockMsgType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
/** Type of tx finalization */
var TxFinalizationReasonType;
(function (TxFinalizationReasonType) {
    /** TX_FINALIZATION_REASON_POST_CONSENSUS - The transaction is finalized by post-consensus */
    TxFinalizationReasonType[TxFinalizationReasonType["TX_FINALIZATION_REASON_POST_CONSENSUS"] = 0] = "TX_FINALIZATION_REASON_POST_CONSENSUS";
    /** TX_FINALIZATION_REASON_PRE_CONSENSUS - The transaction is finalized by pre-consensus */
    TxFinalizationReasonType[TxFinalizationReasonType["TX_FINALIZATION_REASON_PRE_CONSENSUS"] = 1] = "TX_FINALIZATION_REASON_PRE_CONSENSUS";
    TxFinalizationReasonType[TxFinalizationReasonType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TxFinalizationReasonType || (exports.TxFinalizationReasonType = TxFinalizationReasonType = {}));
function txFinalizationReasonTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'TX_FINALIZATION_REASON_POST_CONSENSUS':
            return TxFinalizationReasonType.TX_FINALIZATION_REASON_POST_CONSENSUS;
        case 1:
        case 'TX_FINALIZATION_REASON_PRE_CONSENSUS':
            return TxFinalizationReasonType.TX_FINALIZATION_REASON_PRE_CONSENSUS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TxFinalizationReasonType.UNRECOGNIZED;
    }
}
function txFinalizationReasonTypeToJSON(object) {
    switch (object) {
        case TxFinalizationReasonType.TX_FINALIZATION_REASON_POST_CONSENSUS:
            return 'TX_FINALIZATION_REASON_POST_CONSENSUS';
        case TxFinalizationReasonType.TX_FINALIZATION_REASON_PRE_CONSENSUS:
            return 'TX_FINALIZATION_REASON_PRE_CONSENSUS';
        case TxFinalizationReasonType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
/** Type of message for a tx */
var TxMsgType;
(function (TxMsgType) {
    /** TX_ADDED_TO_MEMPOOL - Tx added to the mempool */
    TxMsgType[TxMsgType["TX_ADDED_TO_MEMPOOL"] = 0] = "TX_ADDED_TO_MEMPOOL";
    /** TX_REMOVED_FROM_MEMPOOL - Tx removed from the mempool */
    TxMsgType[TxMsgType["TX_REMOVED_FROM_MEMPOOL"] = 1] = "TX_REMOVED_FROM_MEMPOOL";
    /** TX_CONFIRMED - Tx confirmed in a block */
    TxMsgType[TxMsgType["TX_CONFIRMED"] = 2] = "TX_CONFIRMED";
    /** TX_FINALIZED - Tx finalized by Avalanche */
    TxMsgType[TxMsgType["TX_FINALIZED"] = 3] = "TX_FINALIZED";
    /** TX_INVALIDATED - Tx invalidated by Avalanche */
    TxMsgType[TxMsgType["TX_INVALIDATED"] = 4] = "TX_INVALIDATED";
    TxMsgType[TxMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TxMsgType || (exports.TxMsgType = TxMsgType = {}));
function txMsgTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'TX_ADDED_TO_MEMPOOL':
            return TxMsgType.TX_ADDED_TO_MEMPOOL;
        case 1:
        case 'TX_REMOVED_FROM_MEMPOOL':
            return TxMsgType.TX_REMOVED_FROM_MEMPOOL;
        case 2:
        case 'TX_CONFIRMED':
            return TxMsgType.TX_CONFIRMED;
        case 3:
        case 'TX_FINALIZED':
            return TxMsgType.TX_FINALIZED;
        case 4:
        case 'TX_INVALIDATED':
            return TxMsgType.TX_INVALIDATED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TxMsgType.UNRECOGNIZED;
    }
}
function txMsgTypeToJSON(object) {
    switch (object) {
        case TxMsgType.TX_ADDED_TO_MEMPOOL:
            return 'TX_ADDED_TO_MEMPOOL';
        case TxMsgType.TX_REMOVED_FROM_MEMPOOL:
            return 'TX_REMOVED_FROM_MEMPOOL';
        case TxMsgType.TX_CONFIRMED:
            return 'TX_CONFIRMED';
        case TxMsgType.TX_FINALIZED:
            return 'TX_FINALIZED';
        case TxMsgType.TX_INVALIDATED:
            return 'TX_INVALIDATED';
        case TxMsgType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
function createBaseBlock() {
    return { blockInfo: undefined };
}
exports.Block = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blockInfo !== undefined) {
            exports.BlockInfo.encode(message.blockInfo, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.blockInfo = exports.BlockInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockInfo: isSet(object.blockInfo)
                ? exports.BlockInfo.fromJSON(object.blockInfo)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.blockInfo !== undefined) {
            obj.blockInfo = exports.BlockInfo.toJSON(message.blockInfo);
        }
        return obj;
    },
    create(base) {
        return exports.Block.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlock();
        message.blockInfo =
            object.blockInfo !== undefined && object.blockInfo !== null
                ? exports.BlockInfo.fromPartial(object.blockInfo)
                : undefined;
        return message;
    },
};
function createBaseBlocks() {
    return { blocks: [] };
}
exports.Blocks = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.blocks) {
            exports.BlockInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlocks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.blocks.push(exports.BlockInfo.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            blocks: globalThis.Array.isArray(object?.blocks)
                ? object.blocks.map((e) => exports.BlockInfo.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.blocks?.length) {
            obj.blocks = message.blocks.map(e => exports.BlockInfo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Blocks.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlocks();
        message.blocks =
            object.blocks?.map(e => exports.BlockInfo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBlockHeader() {
    return {
        rawHeader: new Uint8Array(0),
        root: new Uint8Array(0),
        branch: [],
    };
}
exports.BlockHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rawHeader.length !== 0) {
            writer.uint32(10).bytes(message.rawHeader);
        }
        if (message.root.length !== 0) {
            writer.uint32(18).bytes(message.root);
        }
        for (const v of message.branch) {
            writer.uint32(26).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rawHeader = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.root = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.branch.push(reader.bytes());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rawHeader: isSet(object.rawHeader)
                ? bytesFromBase64(object.rawHeader)
                : new Uint8Array(0),
            root: isSet(object.root)
                ? bytesFromBase64(object.root)
                : new Uint8Array(0),
            branch: globalThis.Array.isArray(object?.branch)
                ? object.branch.map((e) => bytesFromBase64(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rawHeader.length !== 0) {
            obj.rawHeader = base64FromBytes(message.rawHeader);
        }
        if (message.root.length !== 0) {
            obj.root = base64FromBytes(message.root);
        }
        if (message.branch?.length) {
            obj.branch = message.branch.map(e => base64FromBytes(e));
        }
        return obj;
    },
    create(base) {
        return exports.BlockHeader.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockHeader();
        message.rawHeader = object.rawHeader ?? new Uint8Array(0);
        message.root = object.root ?? new Uint8Array(0);
        message.branch = object.branch?.map(e => e) || [];
        return message;
    },
};
function createBaseBlockHeaders() {
    return { headers: [] };
}
exports.BlockHeaders = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.headers) {
            exports.BlockHeader.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockHeaders();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.headers.push(exports.BlockHeader.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            headers: globalThis.Array.isArray(object?.headers)
                ? object.headers.map((e) => exports.BlockHeader.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.headers?.length) {
            obj.headers = message.headers.map(e => exports.BlockHeader.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.BlockHeaders.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockHeaders();
        message.headers =
            object.headers?.map(e => exports.BlockHeader.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBlockchainInfo() {
    return { tipHash: new Uint8Array(0), tipHeight: 0 };
}
exports.BlockchainInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tipHash.length !== 0) {
            writer.uint32(10).bytes(message.tipHash);
        }
        if (message.tipHeight !== 0) {
            writer.uint32(16).int32(message.tipHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockchainInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tipHash = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.tipHeight = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tipHash: isSet(object.tipHash)
                ? bytesFromBase64(object.tipHash)
                : new Uint8Array(0),
            tipHeight: isSet(object.tipHeight)
                ? globalThis.Number(object.tipHeight)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tipHash.length !== 0) {
            obj.tipHash = base64FromBytes(message.tipHash);
        }
        if (message.tipHeight !== 0) {
            obj.tipHeight = Math.round(message.tipHeight);
        }
        return obj;
    },
    create(base) {
        return exports.BlockchainInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockchainInfo();
        message.tipHash = object.tipHash ?? new Uint8Array(0);
        message.tipHeight = object.tipHeight ?? 0;
        return message;
    },
};
function createBaseChronikInfo() {
    return { version: '' };
}
exports.ChronikInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.version !== '') {
            writer.uint32(10).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChronikInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.version = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: isSet(object.version)
                ? globalThis.String(object.version)
                : '',
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.version !== '') {
            obj.version = message.version;
        }
        return obj;
    },
    create(base) {
        return exports.ChronikInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChronikInfo();
        message.version = object.version ?? '';
        return message;
    },
};
function createBaseBlockInfo() {
    return {
        hash: new Uint8Array(0),
        prevHash: new Uint8Array(0),
        height: 0,
        nBits: 0,
        timestamp: 0n,
        isFinal: false,
        blockSize: 0n,
        numTxs: 0n,
        numInputs: 0n,
        numOutputs: 0n,
        sumInputSats: 0n,
        sumCoinbaseOutputSats: 0n,
        sumNormalOutputSats: 0n,
        sumBurnedSats: 0n,
    };
}
exports.BlockInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        if (message.prevHash.length !== 0) {
            writer.uint32(18).bytes(message.prevHash);
        }
        if (message.height !== 0) {
            writer.uint32(24).int32(message.height);
        }
        if (message.nBits !== 0) {
            writer.uint32(32).uint32(message.nBits);
        }
        if (message.timestamp !== 0n) {
            if (BigInt.asIntN(64, message.timestamp) !== message.timestamp) {
                throw new globalThis.Error('value provided for field message.timestamp of type int64 too large');
            }
            writer.uint32(40).int64(message.timestamp.toString());
        }
        if (message.isFinal !== false) {
            writer.uint32(112).bool(message.isFinal);
        }
        if (message.blockSize !== 0n) {
            if (BigInt.asUintN(64, message.blockSize) !== message.blockSize) {
                throw new globalThis.Error('value provided for field message.blockSize of type uint64 too large');
            }
            writer.uint32(48).uint64(message.blockSize.toString());
        }
        if (message.numTxs !== 0n) {
            if (BigInt.asUintN(64, message.numTxs) !== message.numTxs) {
                throw new globalThis.Error('value provided for field message.numTxs of type uint64 too large');
            }
            writer.uint32(56).uint64(message.numTxs.toString());
        }
        if (message.numInputs !== 0n) {
            if (BigInt.asUintN(64, message.numInputs) !== message.numInputs) {
                throw new globalThis.Error('value provided for field message.numInputs of type uint64 too large');
            }
            writer.uint32(64).uint64(message.numInputs.toString());
        }
        if (message.numOutputs !== 0n) {
            if (BigInt.asUintN(64, message.numOutputs) !== message.numOutputs) {
                throw new globalThis.Error('value provided for field message.numOutputs of type uint64 too large');
            }
            writer.uint32(72).uint64(message.numOutputs.toString());
        }
        if (message.sumInputSats !== 0n) {
            if (BigInt.asIntN(64, message.sumInputSats) !== message.sumInputSats) {
                throw new globalThis.Error('value provided for field message.sumInputSats of type int64 too large');
            }
            writer.uint32(80).int64(message.sumInputSats.toString());
        }
        if (message.sumCoinbaseOutputSats !== 0n) {
            if (BigInt.asIntN(64, message.sumCoinbaseOutputSats) !==
                message.sumCoinbaseOutputSats) {
                throw new globalThis.Error('value provided for field message.sumCoinbaseOutputSats of type int64 too large');
            }
            writer.uint32(88).int64(message.sumCoinbaseOutputSats.toString());
        }
        if (message.sumNormalOutputSats !== 0n) {
            if (BigInt.asIntN(64, message.sumNormalOutputSats) !==
                message.sumNormalOutputSats) {
                throw new globalThis.Error('value provided for field message.sumNormalOutputSats of type int64 too large');
            }
            writer.uint32(96).int64(message.sumNormalOutputSats.toString());
        }
        if (message.sumBurnedSats !== 0n) {
            if (BigInt.asIntN(64, message.sumBurnedSats) !==
                message.sumBurnedSats) {
                throw new globalThis.Error('value provided for field message.sumBurnedSats of type int64 too large');
            }
            writer.uint32(104).int64(message.sumBurnedSats.toString());
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.hash = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.prevHash = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.nBits = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.timestamp = longToBigint(reader.int64());
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.isFinal = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.blockSize = longToBigint(reader.uint64());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.numTxs = longToBigint(reader.uint64());
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.numInputs = longToBigint(reader.uint64());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.numOutputs = longToBigint(reader.uint64());
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.sumInputSats = longToBigint(reader.int64());
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.sumCoinbaseOutputSats = longToBigint(reader.int64());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.sumNormalOutputSats = longToBigint(reader.int64());
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.sumBurnedSats = longToBigint(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash)
                ? bytesFromBase64(object.hash)
                : new Uint8Array(0),
            prevHash: isSet(object.prevHash)
                ? bytesFromBase64(object.prevHash)
                : new Uint8Array(0),
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            nBits: isSet(object.nBits) ? globalThis.Number(object.nBits) : 0,
            timestamp: isSet(object.timestamp) ? BigInt(object.timestamp) : 0n,
            isFinal: isSet(object.isFinal)
                ? globalThis.Boolean(object.isFinal)
                : false,
            blockSize: isSet(object.blockSize) ? BigInt(object.blockSize) : 0n,
            numTxs: isSet(object.numTxs) ? BigInt(object.numTxs) : 0n,
            numInputs: isSet(object.numInputs) ? BigInt(object.numInputs) : 0n,
            numOutputs: isSet(object.numOutputs)
                ? BigInt(object.numOutputs)
                : 0n,
            sumInputSats: isSet(object.sumInputSats)
                ? BigInt(object.sumInputSats)
                : 0n,
            sumCoinbaseOutputSats: isSet(object.sumCoinbaseOutputSats)
                ? BigInt(object.sumCoinbaseOutputSats)
                : 0n,
            sumNormalOutputSats: isSet(object.sumNormalOutputSats)
                ? BigInt(object.sumNormalOutputSats)
                : 0n,
            sumBurnedSats: isSet(object.sumBurnedSats)
                ? BigInt(object.sumBurnedSats)
                : 0n,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.hash.length !== 0) {
            obj.hash = base64FromBytes(message.hash);
        }
        if (message.prevHash.length !== 0) {
            obj.prevHash = base64FromBytes(message.prevHash);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.nBits !== 0) {
            obj.nBits = Math.round(message.nBits);
        }
        if (message.timestamp !== 0n) {
            obj.timestamp = message.timestamp.toString();
        }
        if (message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        if (message.blockSize !== 0n) {
            obj.blockSize = message.blockSize.toString();
        }
        if (message.numTxs !== 0n) {
            obj.numTxs = message.numTxs.toString();
        }
        if (message.numInputs !== 0n) {
            obj.numInputs = message.numInputs.toString();
        }
        if (message.numOutputs !== 0n) {
            obj.numOutputs = message.numOutputs.toString();
        }
        if (message.sumInputSats !== 0n) {
            obj.sumInputSats = message.sumInputSats.toString();
        }
        if (message.sumCoinbaseOutputSats !== 0n) {
            obj.sumCoinbaseOutputSats =
                message.sumCoinbaseOutputSats.toString();
        }
        if (message.sumNormalOutputSats !== 0n) {
            obj.sumNormalOutputSats = message.sumNormalOutputSats.toString();
        }
        if (message.sumBurnedSats !== 0n) {
            obj.sumBurnedSats = message.sumBurnedSats.toString();
        }
        return obj;
    },
    create(base) {
        return exports.BlockInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockInfo();
        message.hash = object.hash ?? new Uint8Array(0);
        message.prevHash = object.prevHash ?? new Uint8Array(0);
        message.height = object.height ?? 0;
        message.nBits = object.nBits ?? 0;
        message.timestamp = object.timestamp ?? 0n;
        message.isFinal = object.isFinal ?? false;
        message.blockSize = object.blockSize ?? 0n;
        message.numTxs = object.numTxs ?? 0n;
        message.numInputs = object.numInputs ?? 0n;
        message.numOutputs = object.numOutputs ?? 0n;
        message.sumInputSats = object.sumInputSats ?? 0n;
        message.sumCoinbaseOutputSats = object.sumCoinbaseOutputSats ?? 0n;
        message.sumNormalOutputSats = object.sumNormalOutputSats ?? 0n;
        message.sumBurnedSats = object.sumBurnedSats ?? 0n;
        return message;
    },
};
function createBaseTx() {
    return {
        txid: new Uint8Array(0),
        version: 0,
        inputs: [],
        outputs: [],
        lockTime: 0,
        block: undefined,
        timeFirstSeen: 0n,
        size: 0,
        isCoinbase: false,
        tokenEntries: [],
        tokenFailedParsings: [],
        tokenStatus: 0,
        isFinal: false,
    };
}
exports.Tx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txid.length !== 0) {
            writer.uint32(10).bytes(message.txid);
        }
        if (message.version !== 0) {
            writer.uint32(16).int32(message.version);
        }
        for (const v of message.inputs) {
            exports.TxInput.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.outputs) {
            exports.TxOutput.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.lockTime !== 0) {
            writer.uint32(40).uint32(message.lockTime);
        }
        if (message.block !== undefined) {
            exports.BlockMetadata.encode(message.block, writer.uint32(66).fork()).ldelim();
        }
        if (message.timeFirstSeen !== 0n) {
            if (BigInt.asIntN(64, message.timeFirstSeen) !==
                message.timeFirstSeen) {
                throw new globalThis.Error('value provided for field message.timeFirstSeen of type int64 too large');
            }
            writer.uint32(72).int64(message.timeFirstSeen.toString());
        }
        if (message.size !== 0) {
            writer.uint32(88).uint32(message.size);
        }
        if (message.isCoinbase !== false) {
            writer.uint32(96).bool(message.isCoinbase);
        }
        for (const v of message.tokenEntries) {
            exports.TokenEntry.encode(v, writer.uint32(106).fork()).ldelim();
        }
        for (const v of message.tokenFailedParsings) {
            exports.TokenFailedParsing.encode(v, writer.uint32(114).fork()).ldelim();
        }
        if (message.tokenStatus !== 0) {
            writer.uint32(120).int32(message.tokenStatus);
        }
        if (message.isFinal !== false) {
            writer.uint32(128).bool(message.isFinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txid = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.version = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.inputs.push(exports.TxInput.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.outputs.push(exports.TxOutput.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.lockTime = reader.uint32();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.block = exports.BlockMetadata.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.timeFirstSeen = longToBigint(reader.int64());
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.size = reader.uint32();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.isCoinbase = reader.bool();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.tokenEntries.push(exports.TokenEntry.decode(reader, reader.uint32()));
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.tokenFailedParsings.push(exports.TokenFailedParsing.decode(reader, reader.uint32()));
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.tokenStatus = reader.int32();
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.isFinal = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txid: isSet(object.txid)
                ? bytesFromBase64(object.txid)
                : new Uint8Array(0),
            version: isSet(object.version)
                ? globalThis.Number(object.version)
                : 0,
            inputs: globalThis.Array.isArray(object?.inputs)
                ? object.inputs.map((e) => exports.TxInput.fromJSON(e))
                : [],
            outputs: globalThis.Array.isArray(object?.outputs)
                ? object.outputs.map((e) => exports.TxOutput.fromJSON(e))
                : [],
            lockTime: isSet(object.lockTime)
                ? globalThis.Number(object.lockTime)
                : 0,
            block: isSet(object.block)
                ? exports.BlockMetadata.fromJSON(object.block)
                : undefined,
            timeFirstSeen: isSet(object.timeFirstSeen)
                ? BigInt(object.timeFirstSeen)
                : 0n,
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
            isCoinbase: isSet(object.isCoinbase)
                ? globalThis.Boolean(object.isCoinbase)
                : false,
            tokenEntries: globalThis.Array.isArray(object?.tokenEntries)
                ? object.tokenEntries.map((e) => exports.TokenEntry.fromJSON(e))
                : [],
            tokenFailedParsings: globalThis.Array.isArray(object?.tokenFailedParsings)
                ? object.tokenFailedParsings.map((e) => exports.TokenFailedParsing.fromJSON(e))
                : [],
            tokenStatus: isSet(object.tokenStatus)
                ? tokenStatusFromJSON(object.tokenStatus)
                : 0,
            isFinal: isSet(object.isFinal)
                ? globalThis.Boolean(object.isFinal)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txid.length !== 0) {
            obj.txid = base64FromBytes(message.txid);
        }
        if (message.version !== 0) {
            obj.version = Math.round(message.version);
        }
        if (message.inputs?.length) {
            obj.inputs = message.inputs.map(e => exports.TxInput.toJSON(e));
        }
        if (message.outputs?.length) {
            obj.outputs = message.outputs.map(e => exports.TxOutput.toJSON(e));
        }
        if (message.lockTime !== 0) {
            obj.lockTime = Math.round(message.lockTime);
        }
        if (message.block !== undefined) {
            obj.block = exports.BlockMetadata.toJSON(message.block);
        }
        if (message.timeFirstSeen !== 0n) {
            obj.timeFirstSeen = message.timeFirstSeen.toString();
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        if (message.isCoinbase !== false) {
            obj.isCoinbase = message.isCoinbase;
        }
        if (message.tokenEntries?.length) {
            obj.tokenEntries = message.tokenEntries.map(e => exports.TokenEntry.toJSON(e));
        }
        if (message.tokenFailedParsings?.length) {
            obj.tokenFailedParsings = message.tokenFailedParsings.map(e => exports.TokenFailedParsing.toJSON(e));
        }
        if (message.tokenStatus !== 0) {
            obj.tokenStatus = tokenStatusToJSON(message.tokenStatus);
        }
        if (message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        return obj;
    },
    create(base) {
        return exports.Tx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTx();
        message.txid = object.txid ?? new Uint8Array(0);
        message.version = object.version ?? 0;
        message.inputs = object.inputs?.map(e => exports.TxInput.fromPartial(e)) || [];
        message.outputs =
            object.outputs?.map(e => exports.TxOutput.fromPartial(e)) || [];
        message.lockTime = object.lockTime ?? 0;
        message.block =
            object.block !== undefined && object.block !== null
                ? exports.BlockMetadata.fromPartial(object.block)
                : undefined;
        message.timeFirstSeen = object.timeFirstSeen ?? 0n;
        message.size = object.size ?? 0;
        message.isCoinbase = object.isCoinbase ?? false;
        message.tokenEntries =
            object.tokenEntries?.map(e => exports.TokenEntry.fromPartial(e)) || [];
        message.tokenFailedParsings =
            object.tokenFailedParsings?.map(e => exports.TokenFailedParsing.fromPartial(e)) || [];
        message.tokenStatus = object.tokenStatus ?? 0;
        message.isFinal = object.isFinal ?? false;
        return message;
    },
};
function createBaseScriptUtxo() {
    return {
        outpoint: undefined,
        blockHeight: 0,
        isCoinbase: false,
        sats: 0n,
        isFinal: false,
        token: undefined,
        plugins: {},
    };
}
exports.ScriptUtxo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.outpoint !== undefined) {
            exports.OutPoint.encode(message.outpoint, writer.uint32(10).fork()).ldelim();
        }
        if (message.blockHeight !== 0) {
            writer.uint32(16).int32(message.blockHeight);
        }
        if (message.isCoinbase !== false) {
            writer.uint32(24).bool(message.isCoinbase);
        }
        if (message.sats !== 0n) {
            if (BigInt.asIntN(64, message.sats) !== message.sats) {
                throw new globalThis.Error('value provided for field message.sats of type int64 too large');
            }
            writer.uint32(40).int64(message.sats.toString());
        }
        if (message.isFinal !== false) {
            writer.uint32(80).bool(message.isFinal);
        }
        if (message.token !== undefined) {
            exports.Token.encode(message.token, writer.uint32(90).fork()).ldelim();
        }
        Object.entries(message.plugins).forEach(([key, value]) => {
            exports.ScriptUtxo_PluginsEntry.encode({ key: key, value }, writer.uint32(98).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptUtxo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.outpoint = exports.OutPoint.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.blockHeight = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isCoinbase = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.sats = longToBigint(reader.int64());
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.isFinal = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.token = exports.Token.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    const entry12 = exports.ScriptUtxo_PluginsEntry.decode(reader, reader.uint32());
                    if (entry12.value !== undefined) {
                        message.plugins[entry12.key] = entry12.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            outpoint: isSet(object.outpoint)
                ? exports.OutPoint.fromJSON(object.outpoint)
                : undefined,
            blockHeight: isSet(object.blockHeight)
                ? globalThis.Number(object.blockHeight)
                : 0,
            isCoinbase: isSet(object.isCoinbase)
                ? globalThis.Boolean(object.isCoinbase)
                : false,
            sats: isSet(object.sats) ? BigInt(object.sats) : 0n,
            isFinal: isSet(object.isFinal)
                ? globalThis.Boolean(object.isFinal)
                : false,
            token: isSet(object.token)
                ? exports.Token.fromJSON(object.token)
                : undefined,
            plugins: isObject(object.plugins)
                ? Object.entries(object.plugins).reduce((acc, [key, value]) => {
                    acc[key] = exports.PluginEntry.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.outpoint !== undefined) {
            obj.outpoint = exports.OutPoint.toJSON(message.outpoint);
        }
        if (message.blockHeight !== 0) {
            obj.blockHeight = Math.round(message.blockHeight);
        }
        if (message.isCoinbase !== false) {
            obj.isCoinbase = message.isCoinbase;
        }
        if (message.sats !== 0n) {
            obj.sats = message.sats.toString();
        }
        if (message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        if (message.token !== undefined) {
            obj.token = exports.Token.toJSON(message.token);
        }
        if (message.plugins) {
            const entries = Object.entries(message.plugins);
            if (entries.length > 0) {
                obj.plugins = {};
                entries.forEach(([k, v]) => {
                    obj.plugins[k] = exports.PluginEntry.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.ScriptUtxo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptUtxo();
        message.outpoint =
            object.outpoint !== undefined && object.outpoint !== null
                ? exports.OutPoint.fromPartial(object.outpoint)
                : undefined;
        message.blockHeight = object.blockHeight ?? 0;
        message.isCoinbase = object.isCoinbase ?? false;
        message.sats = object.sats ?? 0n;
        message.isFinal = object.isFinal ?? false;
        message.token =
            object.token !== undefined && object.token !== null
                ? exports.Token.fromPartial(object.token)
                : undefined;
        message.plugins = Object.entries(object.plugins ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.PluginEntry.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseScriptUtxo_PluginsEntry() {
    return { key: '', value: undefined };
}
exports.ScriptUtxo_PluginsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.PluginEntry.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptUtxo_PluginsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.PluginEntry.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value)
                ? exports.PluginEntry.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.PluginEntry.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.ScriptUtxo_PluginsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptUtxo_PluginsEntry();
        message.key = object.key ?? '';
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.PluginEntry.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseUtxo() {
    return {
        outpoint: undefined,
        blockHeight: 0,
        isCoinbase: false,
        sats: 0n,
        script: new Uint8Array(0),
        isFinal: false,
        token: undefined,
        plugins: {},
    };
}
exports.Utxo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.outpoint !== undefined) {
            exports.OutPoint.encode(message.outpoint, writer.uint32(10).fork()).ldelim();
        }
        if (message.blockHeight !== 0) {
            writer.uint32(16).int32(message.blockHeight);
        }
        if (message.isCoinbase !== false) {
            writer.uint32(24).bool(message.isCoinbase);
        }
        if (message.sats !== 0n) {
            if (BigInt.asIntN(64, message.sats) !== message.sats) {
                throw new globalThis.Error('value provided for field message.sats of type int64 too large');
            }
            writer.uint32(32).int64(message.sats.toString());
        }
        if (message.script.length !== 0) {
            writer.uint32(42).bytes(message.script);
        }
        if (message.isFinal !== false) {
            writer.uint32(48).bool(message.isFinal);
        }
        if (message.token !== undefined) {
            exports.Token.encode(message.token, writer.uint32(58).fork()).ldelim();
        }
        Object.entries(message.plugins).forEach(([key, value]) => {
            exports.Utxo_PluginsEntry.encode({ key: key, value }, writer.uint32(66).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUtxo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.outpoint = exports.OutPoint.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.blockHeight = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isCoinbase = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.sats = longToBigint(reader.int64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.script = reader.bytes();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.isFinal = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.token = exports.Token.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    const entry8 = exports.Utxo_PluginsEntry.decode(reader, reader.uint32());
                    if (entry8.value !== undefined) {
                        message.plugins[entry8.key] = entry8.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            outpoint: isSet(object.outpoint)
                ? exports.OutPoint.fromJSON(object.outpoint)
                : undefined,
            blockHeight: isSet(object.blockHeight)
                ? globalThis.Number(object.blockHeight)
                : 0,
            isCoinbase: isSet(object.isCoinbase)
                ? globalThis.Boolean(object.isCoinbase)
                : false,
            sats: isSet(object.sats) ? BigInt(object.sats) : 0n,
            script: isSet(object.script)
                ? bytesFromBase64(object.script)
                : new Uint8Array(0),
            isFinal: isSet(object.isFinal)
                ? globalThis.Boolean(object.isFinal)
                : false,
            token: isSet(object.token)
                ? exports.Token.fromJSON(object.token)
                : undefined,
            plugins: isObject(object.plugins)
                ? Object.entries(object.plugins).reduce((acc, [key, value]) => {
                    acc[key] = exports.PluginEntry.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.outpoint !== undefined) {
            obj.outpoint = exports.OutPoint.toJSON(message.outpoint);
        }
        if (message.blockHeight !== 0) {
            obj.blockHeight = Math.round(message.blockHeight);
        }
        if (message.isCoinbase !== false) {
            obj.isCoinbase = message.isCoinbase;
        }
        if (message.sats !== 0n) {
            obj.sats = message.sats.toString();
        }
        if (message.script.length !== 0) {
            obj.script = base64FromBytes(message.script);
        }
        if (message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        if (message.token !== undefined) {
            obj.token = exports.Token.toJSON(message.token);
        }
        if (message.plugins) {
            const entries = Object.entries(message.plugins);
            if (entries.length > 0) {
                obj.plugins = {};
                entries.forEach(([k, v]) => {
                    obj.plugins[k] = exports.PluginEntry.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.Utxo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUtxo();
        message.outpoint =
            object.outpoint !== undefined && object.outpoint !== null
                ? exports.OutPoint.fromPartial(object.outpoint)
                : undefined;
        message.blockHeight = object.blockHeight ?? 0;
        message.isCoinbase = object.isCoinbase ?? false;
        message.sats = object.sats ?? 0n;
        message.script = object.script ?? new Uint8Array(0);
        message.isFinal = object.isFinal ?? false;
        message.token =
            object.token !== undefined && object.token !== null
                ? exports.Token.fromPartial(object.token)
                : undefined;
        message.plugins = Object.entries(object.plugins ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.PluginEntry.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseUtxo_PluginsEntry() {
    return { key: '', value: undefined };
}
exports.Utxo_PluginsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.PluginEntry.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUtxo_PluginsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.PluginEntry.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value)
                ? exports.PluginEntry.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.PluginEntry.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.Utxo_PluginsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUtxo_PluginsEntry();
        message.key = object.key ?? '';
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.PluginEntry.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseOutPoint() {
    return { txid: new Uint8Array(0), outIdx: 0 };
}
exports.OutPoint = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txid.length !== 0) {
            writer.uint32(10).bytes(message.txid);
        }
        if (message.outIdx !== 0) {
            writer.uint32(16).uint32(message.outIdx);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutPoint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txid = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.outIdx = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txid: isSet(object.txid)
                ? bytesFromBase64(object.txid)
                : new Uint8Array(0),
            outIdx: isSet(object.outIdx) ? globalThis.Number(object.outIdx) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txid.length !== 0) {
            obj.txid = base64FromBytes(message.txid);
        }
        if (message.outIdx !== 0) {
            obj.outIdx = Math.round(message.outIdx);
        }
        return obj;
    },
    create(base) {
        return exports.OutPoint.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutPoint();
        message.txid = object.txid ?? new Uint8Array(0);
        message.outIdx = object.outIdx ?? 0;
        return message;
    },
};
function createBaseSpentBy() {
    return { txid: new Uint8Array(0), inputIdx: 0 };
}
exports.SpentBy = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txid.length !== 0) {
            writer.uint32(10).bytes(message.txid);
        }
        if (message.inputIdx !== 0) {
            writer.uint32(16).uint32(message.inputIdx);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpentBy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txid = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.inputIdx = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txid: isSet(object.txid)
                ? bytesFromBase64(object.txid)
                : new Uint8Array(0),
            inputIdx: isSet(object.inputIdx)
                ? globalThis.Number(object.inputIdx)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txid.length !== 0) {
            obj.txid = base64FromBytes(message.txid);
        }
        if (message.inputIdx !== 0) {
            obj.inputIdx = Math.round(message.inputIdx);
        }
        return obj;
    },
    create(base) {
        return exports.SpentBy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSpentBy();
        message.txid = object.txid ?? new Uint8Array(0);
        message.inputIdx = object.inputIdx ?? 0;
        return message;
    },
};
function createBaseTxInput() {
    return {
        prevOut: undefined,
        inputScript: new Uint8Array(0),
        outputScript: new Uint8Array(0),
        sats: 0n,
        sequenceNo: 0,
        token: undefined,
        plugins: {},
    };
}
exports.TxInput = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.prevOut !== undefined) {
            exports.OutPoint.encode(message.prevOut, writer.uint32(10).fork()).ldelim();
        }
        if (message.inputScript.length !== 0) {
            writer.uint32(18).bytes(message.inputScript);
        }
        if (message.outputScript.length !== 0) {
            writer.uint32(26).bytes(message.outputScript);
        }
        if (message.sats !== 0n) {
            if (BigInt.asIntN(64, message.sats) !== message.sats) {
                throw new globalThis.Error('value provided for field message.sats of type int64 too large');
            }
            writer.uint32(32).int64(message.sats.toString());
        }
        if (message.sequenceNo !== 0) {
            writer.uint32(40).uint32(message.sequenceNo);
        }
        if (message.token !== undefined) {
            exports.Token.encode(message.token, writer.uint32(66).fork()).ldelim();
        }
        Object.entries(message.plugins).forEach(([key, value]) => {
            exports.TxInput_PluginsEntry.encode({ key: key, value }, writer.uint32(74).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxInput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.prevOut = exports.OutPoint.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.inputScript = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.outputScript = reader.bytes();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.sats = longToBigint(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.sequenceNo = reader.uint32();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.token = exports.Token.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    const entry9 = exports.TxInput_PluginsEntry.decode(reader, reader.uint32());
                    if (entry9.value !== undefined) {
                        message.plugins[entry9.key] = entry9.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            prevOut: isSet(object.prevOut)
                ? exports.OutPoint.fromJSON(object.prevOut)
                : undefined,
            inputScript: isSet(object.inputScript)
                ? bytesFromBase64(object.inputScript)
                : new Uint8Array(0),
            outputScript: isSet(object.outputScript)
                ? bytesFromBase64(object.outputScript)
                : new Uint8Array(0),
            sats: isSet(object.sats) ? BigInt(object.sats) : 0n,
            sequenceNo: isSet(object.sequenceNo)
                ? globalThis.Number(object.sequenceNo)
                : 0,
            token: isSet(object.token)
                ? exports.Token.fromJSON(object.token)
                : undefined,
            plugins: isObject(object.plugins)
                ? Object.entries(object.plugins).reduce((acc, [key, value]) => {
                    acc[key] = exports.PluginEntry.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.prevOut !== undefined) {
            obj.prevOut = exports.OutPoint.toJSON(message.prevOut);
        }
        if (message.inputScript.length !== 0) {
            obj.inputScript = base64FromBytes(message.inputScript);
        }
        if (message.outputScript.length !== 0) {
            obj.outputScript = base64FromBytes(message.outputScript);
        }
        if (message.sats !== 0n) {
            obj.sats = message.sats.toString();
        }
        if (message.sequenceNo !== 0) {
            obj.sequenceNo = Math.round(message.sequenceNo);
        }
        if (message.token !== undefined) {
            obj.token = exports.Token.toJSON(message.token);
        }
        if (message.plugins) {
            const entries = Object.entries(message.plugins);
            if (entries.length > 0) {
                obj.plugins = {};
                entries.forEach(([k, v]) => {
                    obj.plugins[k] = exports.PluginEntry.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.TxInput.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTxInput();
        message.prevOut =
            object.prevOut !== undefined && object.prevOut !== null
                ? exports.OutPoint.fromPartial(object.prevOut)
                : undefined;
        message.inputScript = object.inputScript ?? new Uint8Array(0);
        message.outputScript = object.outputScript ?? new Uint8Array(0);
        message.sats = object.sats ?? 0n;
        message.sequenceNo = object.sequenceNo ?? 0;
        message.token =
            object.token !== undefined && object.token !== null
                ? exports.Token.fromPartial(object.token)
                : undefined;
        message.plugins = Object.entries(object.plugins ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.PluginEntry.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseTxInput_PluginsEntry() {
    return { key: '', value: undefined };
}
exports.TxInput_PluginsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.PluginEntry.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxInput_PluginsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.PluginEntry.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value)
                ? exports.PluginEntry.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.PluginEntry.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.TxInput_PluginsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTxInput_PluginsEntry();
        message.key = object.key ?? '';
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.PluginEntry.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseTxOutput() {
    return {
        sats: 0n,
        outputScript: new Uint8Array(0),
        spentBy: undefined,
        token: undefined,
        plugins: {},
    };
}
exports.TxOutput = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sats !== 0n) {
            if (BigInt.asIntN(64, message.sats) !== message.sats) {
                throw new globalThis.Error('value provided for field message.sats of type int64 too large');
            }
            writer.uint32(8).int64(message.sats.toString());
        }
        if (message.outputScript.length !== 0) {
            writer.uint32(18).bytes(message.outputScript);
        }
        if (message.spentBy !== undefined) {
            exports.SpentBy.encode(message.spentBy, writer.uint32(34).fork()).ldelim();
        }
        if (message.token !== undefined) {
            exports.Token.encode(message.token, writer.uint32(42).fork()).ldelim();
        }
        Object.entries(message.plugins).forEach(([key, value]) => {
            exports.TxOutput_PluginsEntry.encode({ key: key, value }, writer.uint32(50).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.sats = longToBigint(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.outputScript = reader.bytes();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.spentBy = exports.SpentBy.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.token = exports.Token.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    const entry6 = exports.TxOutput_PluginsEntry.decode(reader, reader.uint32());
                    if (entry6.value !== undefined) {
                        message.plugins[entry6.key] = entry6.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sats: isSet(object.sats) ? BigInt(object.sats) : 0n,
            outputScript: isSet(object.outputScript)
                ? bytesFromBase64(object.outputScript)
                : new Uint8Array(0),
            spentBy: isSet(object.spentBy)
                ? exports.SpentBy.fromJSON(object.spentBy)
                : undefined,
            token: isSet(object.token)
                ? exports.Token.fromJSON(object.token)
                : undefined,
            plugins: isObject(object.plugins)
                ? Object.entries(object.plugins).reduce((acc, [key, value]) => {
                    acc[key] = exports.PluginEntry.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sats !== 0n) {
            obj.sats = message.sats.toString();
        }
        if (message.outputScript.length !== 0) {
            obj.outputScript = base64FromBytes(message.outputScript);
        }
        if (message.spentBy !== undefined) {
            obj.spentBy = exports.SpentBy.toJSON(message.spentBy);
        }
        if (message.token !== undefined) {
            obj.token = exports.Token.toJSON(message.token);
        }
        if (message.plugins) {
            const entries = Object.entries(message.plugins);
            if (entries.length > 0) {
                obj.plugins = {};
                entries.forEach(([k, v]) => {
                    obj.plugins[k] = exports.PluginEntry.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.TxOutput.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTxOutput();
        message.sats = object.sats ?? 0n;
        message.outputScript = object.outputScript ?? new Uint8Array(0);
        message.spentBy =
            object.spentBy !== undefined && object.spentBy !== null
                ? exports.SpentBy.fromPartial(object.spentBy)
                : undefined;
        message.token =
            object.token !== undefined && object.token !== null
                ? exports.Token.fromPartial(object.token)
                : undefined;
        message.plugins = Object.entries(object.plugins ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.PluginEntry.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseTxOutput_PluginsEntry() {
    return { key: '', value: undefined };
}
exports.TxOutput_PluginsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.PluginEntry.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxOutput_PluginsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.PluginEntry.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value)
                ? exports.PluginEntry.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.PluginEntry.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.TxOutput_PluginsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTxOutput_PluginsEntry();
        message.key = object.key ?? '';
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.PluginEntry.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseBlockMetadata() {
    return {
        height: 0,
        hash: new Uint8Array(0),
        timestamp: 0n,
        isFinal: false,
    };
}
exports.BlockMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.height !== 0) {
            writer.uint32(8).int32(message.height);
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        if (message.timestamp !== 0n) {
            if (BigInt.asIntN(64, message.timestamp) !== message.timestamp) {
                throw new globalThis.Error('value provided for field message.timestamp of type int64 too large');
            }
            writer.uint32(24).int64(message.timestamp.toString());
        }
        if (message.isFinal !== false) {
            writer.uint32(32).bool(message.isFinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.hash = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.timestamp = longToBigint(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.isFinal = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            hash: isSet(object.hash)
                ? bytesFromBase64(object.hash)
                : new Uint8Array(0),
            timestamp: isSet(object.timestamp) ? BigInt(object.timestamp) : 0n,
            isFinal: isSet(object.isFinal)
                ? globalThis.Boolean(object.isFinal)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.hash.length !== 0) {
            obj.hash = base64FromBytes(message.hash);
        }
        if (message.timestamp !== 0n) {
            obj.timestamp = message.timestamp.toString();
        }
        if (message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        return obj;
    },
    create(base) {
        return exports.BlockMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockMetadata();
        message.height = object.height ?? 0;
        message.hash = object.hash ?? new Uint8Array(0);
        message.timestamp = object.timestamp ?? 0n;
        message.isFinal = object.isFinal ?? false;
        return message;
    },
};
function createBaseTokenType() {
    return { slp: undefined, alp: undefined };
}
exports.TokenType = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.slp !== undefined) {
            writer.uint32(8).int32(message.slp);
        }
        if (message.alp !== undefined) {
            writer.uint32(16).int32(message.alp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenType();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.slp = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.alp = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            slp: isSet(object.slp)
                ? slpTokenTypeFromJSON(object.slp)
                : undefined,
            alp: isSet(object.alp)
                ? alpTokenTypeFromJSON(object.alp)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.slp !== undefined) {
            obj.slp = slpTokenTypeToJSON(message.slp);
        }
        if (message.alp !== undefined) {
            obj.alp = alpTokenTypeToJSON(message.alp);
        }
        return obj;
    },
    create(base) {
        return exports.TokenType.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenType();
        message.slp = object.slp ?? undefined;
        message.alp = object.alp ?? undefined;
        return message;
    },
};
function createBaseTokenInfo() {
    return {
        tokenId: '',
        tokenType: undefined,
        genesisInfo: undefined,
        block: undefined,
        timeFirstSeen: 0n,
    };
}
exports.TokenInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenId !== '') {
            writer.uint32(10).string(message.tokenId);
        }
        if (message.tokenType !== undefined) {
            exports.TokenType.encode(message.tokenType, writer.uint32(18).fork()).ldelim();
        }
        if (message.genesisInfo !== undefined) {
            exports.GenesisInfo.encode(message.genesisInfo, writer.uint32(26).fork()).ldelim();
        }
        if (message.block !== undefined) {
            exports.BlockMetadata.encode(message.block, writer.uint32(34).fork()).ldelim();
        }
        if (message.timeFirstSeen !== 0n) {
            if (BigInt.asIntN(64, message.timeFirstSeen) !==
                message.timeFirstSeen) {
                throw new globalThis.Error('value provided for field message.timeFirstSeen of type int64 too large');
            }
            writer.uint32(40).int64(message.timeFirstSeen.toString());
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tokenId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tokenType = exports.TokenType.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.genesisInfo = exports.GenesisInfo.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.block = exports.BlockMetadata.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.timeFirstSeen = longToBigint(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tokenId: isSet(object.tokenId)
                ? globalThis.String(object.tokenId)
                : '',
            tokenType: isSet(object.tokenType)
                ? exports.TokenType.fromJSON(object.tokenType)
                : undefined,
            genesisInfo: isSet(object.genesisInfo)
                ? exports.GenesisInfo.fromJSON(object.genesisInfo)
                : undefined,
            block: isSet(object.block)
                ? exports.BlockMetadata.fromJSON(object.block)
                : undefined,
            timeFirstSeen: isSet(object.timeFirstSeen)
                ? BigInt(object.timeFirstSeen)
                : 0n,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenId !== '') {
            obj.tokenId = message.tokenId;
        }
        if (message.tokenType !== undefined) {
            obj.tokenType = exports.TokenType.toJSON(message.tokenType);
        }
        if (message.genesisInfo !== undefined) {
            obj.genesisInfo = exports.GenesisInfo.toJSON(message.genesisInfo);
        }
        if (message.block !== undefined) {
            obj.block = exports.BlockMetadata.toJSON(message.block);
        }
        if (message.timeFirstSeen !== 0n) {
            obj.timeFirstSeen = message.timeFirstSeen.toString();
        }
        return obj;
    },
    create(base) {
        return exports.TokenInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenInfo();
        message.tokenId = object.tokenId ?? '';
        message.tokenType =
            object.tokenType !== undefined && object.tokenType !== null
                ? exports.TokenType.fromPartial(object.tokenType)
                : undefined;
        message.genesisInfo =
            object.genesisInfo !== undefined && object.genesisInfo !== null
                ? exports.GenesisInfo.fromPartial(object.genesisInfo)
                : undefined;
        message.block =
            object.block !== undefined && object.block !== null
                ? exports.BlockMetadata.fromPartial(object.block)
                : undefined;
        message.timeFirstSeen = object.timeFirstSeen ?? 0n;
        return message;
    },
};
function createBaseTokenEntry() {
    return {
        tokenId: '',
        tokenType: undefined,
        txType: 0,
        groupTokenId: '',
        isInvalid: false,
        burnSummary: '',
        failedColorings: [],
        actualBurnAtoms: '',
        intentionalBurnAtoms: 0n,
        burnsMintBatons: false,
    };
}
exports.TokenEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenId !== '') {
            writer.uint32(10).string(message.tokenId);
        }
        if (message.tokenType !== undefined) {
            exports.TokenType.encode(message.tokenType, writer.uint32(18).fork()).ldelim();
        }
        if (message.txType !== 0) {
            writer.uint32(24).int32(message.txType);
        }
        if (message.groupTokenId !== '') {
            writer.uint32(34).string(message.groupTokenId);
        }
        if (message.isInvalid !== false) {
            writer.uint32(40).bool(message.isInvalid);
        }
        if (message.burnSummary !== '') {
            writer.uint32(50).string(message.burnSummary);
        }
        for (const v of message.failedColorings) {
            exports.TokenFailedColoring.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.actualBurnAtoms !== '') {
            writer.uint32(66).string(message.actualBurnAtoms);
        }
        if (message.intentionalBurnAtoms !== 0n) {
            if (BigInt.asUintN(64, message.intentionalBurnAtoms) !==
                message.intentionalBurnAtoms) {
                throw new globalThis.Error('value provided for field message.intentionalBurnAtoms of type uint64 too large');
            }
            writer.uint32(72).uint64(message.intentionalBurnAtoms.toString());
        }
        if (message.burnsMintBatons !== false) {
            writer.uint32(80).bool(message.burnsMintBatons);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tokenId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tokenType = exports.TokenType.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.txType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.groupTokenId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.isInvalid = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.burnSummary = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.failedColorings.push(exports.TokenFailedColoring.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.actualBurnAtoms = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.intentionalBurnAtoms = longToBigint(reader.uint64());
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.burnsMintBatons = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tokenId: isSet(object.tokenId)
                ? globalThis.String(object.tokenId)
                : '',
            tokenType: isSet(object.tokenType)
                ? exports.TokenType.fromJSON(object.tokenType)
                : undefined,
            txType: isSet(object.txType)
                ? tokenTxTypeFromJSON(object.txType)
                : 0,
            groupTokenId: isSet(object.groupTokenId)
                ? globalThis.String(object.groupTokenId)
                : '',
            isInvalid: isSet(object.isInvalid)
                ? globalThis.Boolean(object.isInvalid)
                : false,
            burnSummary: isSet(object.burnSummary)
                ? globalThis.String(object.burnSummary)
                : '',
            failedColorings: globalThis.Array.isArray(object?.failedColorings)
                ? object.failedColorings.map((e) => exports.TokenFailedColoring.fromJSON(e))
                : [],
            actualBurnAtoms: isSet(object.actualBurnAtoms)
                ? globalThis.String(object.actualBurnAtoms)
                : '',
            intentionalBurnAtoms: isSet(object.intentionalBurnAtoms)
                ? BigInt(object.intentionalBurnAtoms)
                : 0n,
            burnsMintBatons: isSet(object.burnsMintBatons)
                ? globalThis.Boolean(object.burnsMintBatons)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenId !== '') {
            obj.tokenId = message.tokenId;
        }
        if (message.tokenType !== undefined) {
            obj.tokenType = exports.TokenType.toJSON(message.tokenType);
        }
        if (message.txType !== 0) {
            obj.txType = tokenTxTypeToJSON(message.txType);
        }
        if (message.groupTokenId !== '') {
            obj.groupTokenId = message.groupTokenId;
        }
        if (message.isInvalid !== false) {
            obj.isInvalid = message.isInvalid;
        }
        if (message.burnSummary !== '') {
            obj.burnSummary = message.burnSummary;
        }
        if (message.failedColorings?.length) {
            obj.failedColorings = message.failedColorings.map(e => exports.TokenFailedColoring.toJSON(e));
        }
        if (message.actualBurnAtoms !== '') {
            obj.actualBurnAtoms = message.actualBurnAtoms;
        }
        if (message.intentionalBurnAtoms !== 0n) {
            obj.intentionalBurnAtoms = message.intentionalBurnAtoms.toString();
        }
        if (message.burnsMintBatons !== false) {
            obj.burnsMintBatons = message.burnsMintBatons;
        }
        return obj;
    },
    create(base) {
        return exports.TokenEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenEntry();
        message.tokenId = object.tokenId ?? '';
        message.tokenType =
            object.tokenType !== undefined && object.tokenType !== null
                ? exports.TokenType.fromPartial(object.tokenType)
                : undefined;
        message.txType = object.txType ?? 0;
        message.groupTokenId = object.groupTokenId ?? '';
        message.isInvalid = object.isInvalid ?? false;
        message.burnSummary = object.burnSummary ?? '';
        message.failedColorings =
            object.failedColorings?.map(e => exports.TokenFailedColoring.fromPartial(e)) || [];
        message.actualBurnAtoms = object.actualBurnAtoms ?? '';
        message.intentionalBurnAtoms = object.intentionalBurnAtoms ?? 0n;
        message.burnsMintBatons = object.burnsMintBatons ?? false;
        return message;
    },
};
function createBaseGenesisInfo() {
    return {
        tokenTicker: new Uint8Array(0),
        tokenName: new Uint8Array(0),
        url: new Uint8Array(0),
        hash: new Uint8Array(0),
        mintVaultScripthash: new Uint8Array(0),
        data: new Uint8Array(0),
        authPubkey: new Uint8Array(0),
        decimals: 0,
    };
}
exports.GenesisInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenTicker.length !== 0) {
            writer.uint32(10).bytes(message.tokenTicker);
        }
        if (message.tokenName.length !== 0) {
            writer.uint32(18).bytes(message.tokenName);
        }
        if (message.url.length !== 0) {
            writer.uint32(26).bytes(message.url);
        }
        if (message.hash.length !== 0) {
            writer.uint32(34).bytes(message.hash);
        }
        if (message.mintVaultScripthash.length !== 0) {
            writer.uint32(42).bytes(message.mintVaultScripthash);
        }
        if (message.data.length !== 0) {
            writer.uint32(50).bytes(message.data);
        }
        if (message.authPubkey.length !== 0) {
            writer.uint32(58).bytes(message.authPubkey);
        }
        if (message.decimals !== 0) {
            writer.uint32(64).uint32(message.decimals);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenesisInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tokenTicker = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tokenName = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.url = reader.bytes();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.hash = reader.bytes();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.mintVaultScripthash = reader.bytes();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.data = reader.bytes();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.authPubkey = reader.bytes();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.decimals = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tokenTicker: isSet(object.tokenTicker)
                ? bytesFromBase64(object.tokenTicker)
                : new Uint8Array(0),
            tokenName: isSet(object.tokenName)
                ? bytesFromBase64(object.tokenName)
                : new Uint8Array(0),
            url: isSet(object.url)
                ? bytesFromBase64(object.url)
                : new Uint8Array(0),
            hash: isSet(object.hash)
                ? bytesFromBase64(object.hash)
                : new Uint8Array(0),
            mintVaultScripthash: isSet(object.mintVaultScripthash)
                ? bytesFromBase64(object.mintVaultScripthash)
                : new Uint8Array(0),
            data: isSet(object.data)
                ? bytesFromBase64(object.data)
                : new Uint8Array(0),
            authPubkey: isSet(object.authPubkey)
                ? bytesFromBase64(object.authPubkey)
                : new Uint8Array(0),
            decimals: isSet(object.decimals)
                ? globalThis.Number(object.decimals)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenTicker.length !== 0) {
            obj.tokenTicker = base64FromBytes(message.tokenTicker);
        }
        if (message.tokenName.length !== 0) {
            obj.tokenName = base64FromBytes(message.tokenName);
        }
        if (message.url.length !== 0) {
            obj.url = base64FromBytes(message.url);
        }
        if (message.hash.length !== 0) {
            obj.hash = base64FromBytes(message.hash);
        }
        if (message.mintVaultScripthash.length !== 0) {
            obj.mintVaultScripthash = base64FromBytes(message.mintVaultScripthash);
        }
        if (message.data.length !== 0) {
            obj.data = base64FromBytes(message.data);
        }
        if (message.authPubkey.length !== 0) {
            obj.authPubkey = base64FromBytes(message.authPubkey);
        }
        if (message.decimals !== 0) {
            obj.decimals = Math.round(message.decimals);
        }
        return obj;
    },
    create(base) {
        return exports.GenesisInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGenesisInfo();
        message.tokenTicker = object.tokenTicker ?? new Uint8Array(0);
        message.tokenName = object.tokenName ?? new Uint8Array(0);
        message.url = object.url ?? new Uint8Array(0);
        message.hash = object.hash ?? new Uint8Array(0);
        message.mintVaultScripthash =
            object.mintVaultScripthash ?? new Uint8Array(0);
        message.data = object.data ?? new Uint8Array(0);
        message.authPubkey = object.authPubkey ?? new Uint8Array(0);
        message.decimals = object.decimals ?? 0;
        return message;
    },
};
function createBaseToken() {
    return {
        tokenId: '',
        tokenType: undefined,
        entryIdx: 0,
        atoms: 0n,
        isMintBaton: false,
    };
}
exports.Token = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenId !== '') {
            writer.uint32(10).string(message.tokenId);
        }
        if (message.tokenType !== undefined) {
            exports.TokenType.encode(message.tokenType, writer.uint32(18).fork()).ldelim();
        }
        if (message.entryIdx !== 0) {
            writer.uint32(24).int32(message.entryIdx);
        }
        if (message.atoms !== 0n) {
            if (BigInt.asUintN(64, message.atoms) !== message.atoms) {
                throw new globalThis.Error('value provided for field message.atoms of type uint64 too large');
            }
            writer.uint32(32).uint64(message.atoms.toString());
        }
        if (message.isMintBaton !== false) {
            writer.uint32(40).bool(message.isMintBaton);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToken();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tokenId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tokenType = exports.TokenType.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.entryIdx = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.atoms = longToBigint(reader.uint64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.isMintBaton = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tokenId: isSet(object.tokenId)
                ? globalThis.String(object.tokenId)
                : '',
            tokenType: isSet(object.tokenType)
                ? exports.TokenType.fromJSON(object.tokenType)
                : undefined,
            entryIdx: isSet(object.entryIdx)
                ? globalThis.Number(object.entryIdx)
                : 0,
            atoms: isSet(object.atoms) ? BigInt(object.atoms) : 0n,
            isMintBaton: isSet(object.isMintBaton)
                ? globalThis.Boolean(object.isMintBaton)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenId !== '') {
            obj.tokenId = message.tokenId;
        }
        if (message.tokenType !== undefined) {
            obj.tokenType = exports.TokenType.toJSON(message.tokenType);
        }
        if (message.entryIdx !== 0) {
            obj.entryIdx = Math.round(message.entryIdx);
        }
        if (message.atoms !== 0n) {
            obj.atoms = message.atoms.toString();
        }
        if (message.isMintBaton !== false) {
            obj.isMintBaton = message.isMintBaton;
        }
        return obj;
    },
    create(base) {
        return exports.Token.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseToken();
        message.tokenId = object.tokenId ?? '';
        message.tokenType =
            object.tokenType !== undefined && object.tokenType !== null
                ? exports.TokenType.fromPartial(object.tokenType)
                : undefined;
        message.entryIdx = object.entryIdx ?? 0;
        message.atoms = object.atoms ?? 0n;
        message.isMintBaton = object.isMintBaton ?? false;
        return message;
    },
};
function createBaseTokenFailedParsing() {
    return { pushdataIdx: 0, bytes: new Uint8Array(0), error: '' };
}
exports.TokenFailedParsing = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pushdataIdx !== 0) {
            writer.uint32(8).int32(message.pushdataIdx);
        }
        if (message.bytes.length !== 0) {
            writer.uint32(18).bytes(message.bytes);
        }
        if (message.error !== '') {
            writer.uint32(26).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenFailedParsing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.pushdataIdx = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.bytes = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.error = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pushdataIdx: isSet(object.pushdataIdx)
                ? globalThis.Number(object.pushdataIdx)
                : 0,
            bytes: isSet(object.bytes)
                ? bytesFromBase64(object.bytes)
                : new Uint8Array(0),
            error: isSet(object.error) ? globalThis.String(object.error) : '',
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pushdataIdx !== 0) {
            obj.pushdataIdx = Math.round(message.pushdataIdx);
        }
        if (message.bytes.length !== 0) {
            obj.bytes = base64FromBytes(message.bytes);
        }
        if (message.error !== '') {
            obj.error = message.error;
        }
        return obj;
    },
    create(base) {
        return exports.TokenFailedParsing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenFailedParsing();
        message.pushdataIdx = object.pushdataIdx ?? 0;
        message.bytes = object.bytes ?? new Uint8Array(0);
        message.error = object.error ?? '';
        return message;
    },
};
function createBaseTokenFailedColoring() {
    return { pushdataIdx: 0, error: '' };
}
exports.TokenFailedColoring = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pushdataIdx !== 0) {
            writer.uint32(8).int32(message.pushdataIdx);
        }
        if (message.error !== '') {
            writer.uint32(26).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenFailedColoring();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.pushdataIdx = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.error = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pushdataIdx: isSet(object.pushdataIdx)
                ? globalThis.Number(object.pushdataIdx)
                : 0,
            error: isSet(object.error) ? globalThis.String(object.error) : '',
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pushdataIdx !== 0) {
            obj.pushdataIdx = Math.round(message.pushdataIdx);
        }
        if (message.error !== '') {
            obj.error = message.error;
        }
        return obj;
    },
    create(base) {
        return exports.TokenFailedColoring.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenFailedColoring();
        message.pushdataIdx = object.pushdataIdx ?? 0;
        message.error = object.error ?? '';
        return message;
    },
};
function createBasePluginEntry() {
    return { groups: [], data: [] };
}
exports.PluginEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.groups) {
            writer.uint32(10).bytes(v);
        }
        for (const v of message.data) {
            writer.uint32(18).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePluginEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.groups.push(reader.bytes());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data.push(reader.bytes());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            groups: globalThis.Array.isArray(object?.groups)
                ? object.groups.map((e) => bytesFromBase64(e))
                : [],
            data: globalThis.Array.isArray(object?.data)
                ? object.data.map((e) => bytesFromBase64(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.groups?.length) {
            obj.groups = message.groups.map(e => base64FromBytes(e));
        }
        if (message.data?.length) {
            obj.data = message.data.map(e => base64FromBytes(e));
        }
        return obj;
    },
    create(base) {
        return exports.PluginEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePluginEntry();
        message.groups = object.groups?.map(e => e) || [];
        message.data = object.data?.map(e => e) || [];
        return message;
    },
};
function createBasePluginGroup() {
    return { group: new Uint8Array(0) };
}
exports.PluginGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.group.length !== 0) {
            writer.uint32(10).bytes(message.group);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePluginGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.group = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            group: isSet(object.group)
                ? bytesFromBase64(object.group)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.group.length !== 0) {
            obj.group = base64FromBytes(message.group);
        }
        return obj;
    },
    create(base) {
        return exports.PluginGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePluginGroup();
        message.group = object.group ?? new Uint8Array(0);
        return message;
    },
};
function createBasePluginGroups() {
    return { groups: [], nextStart: new Uint8Array(0) };
}
exports.PluginGroups = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.groups) {
            exports.PluginGroup.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.nextStart.length !== 0) {
            writer.uint32(18).bytes(message.nextStart);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePluginGroups();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.groups.push(exports.PluginGroup.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nextStart = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            groups: globalThis.Array.isArray(object?.groups)
                ? object.groups.map((e) => exports.PluginGroup.fromJSON(e))
                : [],
            nextStart: isSet(object.nextStart)
                ? bytesFromBase64(object.nextStart)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.groups?.length) {
            obj.groups = message.groups.map(e => exports.PluginGroup.toJSON(e));
        }
        if (message.nextStart.length !== 0) {
            obj.nextStart = base64FromBytes(message.nextStart);
        }
        return obj;
    },
    create(base) {
        return exports.PluginGroups.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePluginGroups();
        message.groups =
            object.groups?.map(e => exports.PluginGroup.fromPartial(e)) || [];
        message.nextStart = object.nextStart ?? new Uint8Array(0);
        return message;
    },
};
function createBaseTxHistoryPage() {
    return { txs: [], numPages: 0, numTxs: 0 };
}
exports.TxHistoryPage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.txs) {
            exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.numPages !== 0) {
            writer.uint32(16).uint32(message.numPages);
        }
        if (message.numTxs !== 0) {
            writer.uint32(24).uint32(message.numTxs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxHistoryPage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txs.push(exports.Tx.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.numPages = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.numTxs = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: globalThis.Array.isArray(object?.txs)
                ? object.txs.map((e) => exports.Tx.fromJSON(e))
                : [],
            numPages: isSet(object.numPages)
                ? globalThis.Number(object.numPages)
                : 0,
            numTxs: isSet(object.numTxs) ? globalThis.Number(object.numTxs) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs?.length) {
            obj.txs = message.txs.map(e => exports.Tx.toJSON(e));
        }
        if (message.numPages !== 0) {
            obj.numPages = Math.round(message.numPages);
        }
        if (message.numTxs !== 0) {
            obj.numTxs = Math.round(message.numTxs);
        }
        return obj;
    },
    create(base) {
        return exports.TxHistoryPage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTxHistoryPage();
        message.txs = object.txs?.map(e => exports.Tx.fromPartial(e)) || [];
        message.numPages = object.numPages ?? 0;
        message.numTxs = object.numTxs ?? 0;
        return message;
    },
};
function createBaseScriptUtxos() {
    return { script: new Uint8Array(0), utxos: [] };
}
exports.ScriptUtxos = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.script.length !== 0) {
            writer.uint32(10).bytes(message.script);
        }
        for (const v of message.utxos) {
            exports.ScriptUtxo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptUtxos();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.script = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.utxos.push(exports.ScriptUtxo.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            script: isSet(object.script)
                ? bytesFromBase64(object.script)
                : new Uint8Array(0),
            utxos: globalThis.Array.isArray(object?.utxos)
                ? object.utxos.map((e) => exports.ScriptUtxo.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.script.length !== 0) {
            obj.script = base64FromBytes(message.script);
        }
        if (message.utxos?.length) {
            obj.utxos = message.utxos.map(e => exports.ScriptUtxo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ScriptUtxos.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptUtxos();
        message.script = object.script ?? new Uint8Array(0);
        message.utxos = object.utxos?.map(e => exports.ScriptUtxo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseScriptRef() {
    return { scriptType: '', payload: new Uint8Array(0) };
}
exports.ScriptRef = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.scriptType !== '') {
            writer.uint32(10).string(message.scriptType);
        }
        if (message.payload.length !== 0) {
            writer.uint32(18).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptRef();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.scriptType = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            scriptType: isSet(object.scriptType)
                ? globalThis.String(object.scriptType)
                : '',
            payload: isSet(object.payload)
                ? bytesFromBase64(object.payload)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.scriptType !== '') {
            obj.scriptType = message.scriptType;
        }
        if (message.payload.length !== 0) {
            obj.payload = base64FromBytes(message.payload);
        }
        return obj;
    },
    create(base) {
        return exports.ScriptRef.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptRef();
        message.scriptType = object.scriptType ?? '';
        message.payload = object.payload ?? new Uint8Array(0);
        return message;
    },
};
function createBaseScriptBatchUtxosParams() {
    return { scripts: [] };
}
exports.ScriptBatchUtxosParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.scripts) {
            exports.ScriptRef.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchUtxosParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.scripts.push(exports.ScriptRef.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            scripts: globalThis.Array.isArray(object?.scripts)
                ? object.scripts.map((e) => exports.ScriptRef.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.scripts?.length) {
            obj.scripts = message.scripts.map(e => exports.ScriptRef.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchUtxosParams.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchUtxosParams();
        message.scripts =
            object.scripts?.map(e => exports.ScriptRef.fromPartial(e)) || [];
        return message;
    },
};
function createBaseScriptBatchUtxosRequest() {
    return { params: undefined };
}
exports.ScriptBatchUtxosRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            exports.ScriptBatchUtxosParams.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchUtxosRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.params = exports.ScriptBatchUtxosParams.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params)
                ? exports.ScriptBatchUtxosParams.fromJSON(object.params)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.params !== undefined) {
            obj.params = exports.ScriptBatchUtxosParams.toJSON(message.params);
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchUtxosRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchUtxosRequest();
        message.params =
            object.params !== undefined && object.params !== null
                ? exports.ScriptBatchUtxosParams.fromPartial(object.params)
                : undefined;
        return message;
    },
};
function createBaseScriptBatchUtxosRow() {
    return { script: undefined, utxos: undefined };
}
exports.ScriptBatchUtxosRow = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.script !== undefined) {
            exports.ScriptRef.encode(message.script, writer.uint32(10).fork()).ldelim();
        }
        if (message.utxos !== undefined) {
            exports.ScriptUtxos.encode(message.utxos, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchUtxosRow();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.script = exports.ScriptRef.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.utxos = exports.ScriptUtxos.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            script: isSet(object.script)
                ? exports.ScriptRef.fromJSON(object.script)
                : undefined,
            utxos: isSet(object.utxos)
                ? exports.ScriptUtxos.fromJSON(object.utxos)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.script !== undefined) {
            obj.script = exports.ScriptRef.toJSON(message.script);
        }
        if (message.utxos !== undefined) {
            obj.utxos = exports.ScriptUtxos.toJSON(message.utxos);
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchUtxosRow.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchUtxosRow();
        message.script =
            object.script !== undefined && object.script !== null
                ? exports.ScriptRef.fromPartial(object.script)
                : undefined;
        message.utxos =
            object.utxos !== undefined && object.utxos !== null
                ? exports.ScriptUtxos.fromPartial(object.utxos)
                : undefined;
        return message;
    },
};
function createBaseScriptBatchUtxosResponse() {
    return { rows: [] };
}
exports.ScriptBatchUtxosResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rows) {
            exports.ScriptBatchUtxosRow.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchUtxosResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rows.push(exports.ScriptBatchUtxosRow.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rows: globalThis.Array.isArray(object?.rows)
                ? object.rows.map((e) => exports.ScriptBatchUtxosRow.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rows?.length) {
            obj.rows = message.rows.map(e => exports.ScriptBatchUtxosRow.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchUtxosResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchUtxosResponse();
        message.rows =
            object.rows?.map(e => exports.ScriptBatchUtxosRow.fromPartial(e)) || [];
        return message;
    },
};
function createBaseScriptBatchSummaryParams() {
    return { scripts: [] };
}
exports.ScriptBatchSummaryParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.scripts) {
            exports.ScriptRef.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchSummaryParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.scripts.push(exports.ScriptRef.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            scripts: globalThis.Array.isArray(object?.scripts)
                ? object.scripts.map((e) => exports.ScriptRef.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.scripts?.length) {
            obj.scripts = message.scripts.map(e => exports.ScriptRef.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchSummaryParams.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchSummaryParams();
        message.scripts =
            object.scripts?.map(e => exports.ScriptRef.fromPartial(e)) || [];
        return message;
    },
};
function createBaseScriptBatchSummaryRequest() {
    return { params: undefined };
}
exports.ScriptBatchSummaryRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            exports.ScriptBatchSummaryParams.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchSummaryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.params = exports.ScriptBatchSummaryParams.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params)
                ? exports.ScriptBatchSummaryParams.fromJSON(object.params)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.params !== undefined) {
            obj.params = exports.ScriptBatchSummaryParams.toJSON(message.params);
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchSummaryRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchSummaryRequest();
        message.params =
            object.params !== undefined && object.params !== null
                ? exports.ScriptBatchSummaryParams.fromPartial(object.params)
                : undefined;
        return message;
    },
};
function createBaseScriptBatchSummaryRow() {
    return { script: undefined, numTxs: 0, numUtxos: 0, latestTx: undefined };
}
exports.ScriptBatchSummaryRow = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.script !== undefined) {
            exports.ScriptRef.encode(message.script, writer.uint32(10).fork()).ldelim();
        }
        if (message.numTxs !== 0) {
            writer.uint32(16).uint32(message.numTxs);
        }
        if (message.numUtxos !== 0) {
            writer.uint32(24).uint32(message.numUtxos);
        }
        if (message.latestTx !== undefined) {
            exports.Tx.encode(message.latestTx, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchSummaryRow();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.script = exports.ScriptRef.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.numTxs = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.numUtxos = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.latestTx = exports.Tx.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            script: isSet(object.script)
                ? exports.ScriptRef.fromJSON(object.script)
                : undefined,
            numTxs: isSet(object.numTxs) ? globalThis.Number(object.numTxs) : 0,
            numUtxos: isSet(object.numUtxos)
                ? globalThis.Number(object.numUtxos)
                : 0,
            latestTx: isSet(object.latestTx)
                ? exports.Tx.fromJSON(object.latestTx)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.script !== undefined) {
            obj.script = exports.ScriptRef.toJSON(message.script);
        }
        if (message.numTxs !== 0) {
            obj.numTxs = Math.round(message.numTxs);
        }
        if (message.numUtxos !== 0) {
            obj.numUtxos = Math.round(message.numUtxos);
        }
        if (message.latestTx !== undefined) {
            obj.latestTx = exports.Tx.toJSON(message.latestTx);
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchSummaryRow.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchSummaryRow();
        message.script =
            object.script !== undefined && object.script !== null
                ? exports.ScriptRef.fromPartial(object.script)
                : undefined;
        message.numTxs = object.numTxs ?? 0;
        message.numUtxos = object.numUtxos ?? 0;
        message.latestTx =
            object.latestTx !== undefined && object.latestTx !== null
                ? exports.Tx.fromPartial(object.latestTx)
                : undefined;
        return message;
    },
};
function createBaseScriptBatchSummaryResponse() {
    return { rows: [] };
}
exports.ScriptBatchSummaryResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rows) {
            exports.ScriptBatchSummaryRow.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScriptBatchSummaryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rows.push(exports.ScriptBatchSummaryRow.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rows: globalThis.Array.isArray(object?.rows)
                ? object.rows.map((e) => exports.ScriptBatchSummaryRow.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rows?.length) {
            obj.rows = message.rows.map(e => exports.ScriptBatchSummaryRow.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ScriptBatchSummaryResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScriptBatchSummaryResponse();
        message.rows =
            object.rows?.map(e => exports.ScriptBatchSummaryRow.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUtxos() {
    return { utxos: [] };
}
exports.Utxos = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.utxos) {
            exports.Utxo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUtxos();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.utxos.push(exports.Utxo.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            utxos: globalThis.Array.isArray(object?.utxos)
                ? object.utxos.map((e) => exports.Utxo.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.utxos?.length) {
            obj.utxos = message.utxos.map(e => exports.Utxo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Utxos.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUtxos();
        message.utxos = object.utxos?.map(e => exports.Utxo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBroadcastTxRequest() {
    return {
        rawTx: new Uint8Array(0),
        skipTokenChecks: false,
        finalizationTimeoutSecs: 0n,
    };
}
exports.BroadcastTxRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rawTx.length !== 0) {
            writer.uint32(10).bytes(message.rawTx);
        }
        if (message.skipTokenChecks !== false) {
            writer.uint32(16).bool(message.skipTokenChecks);
        }
        if (message.finalizationTimeoutSecs !== 0n) {
            if (BigInt.asUintN(64, message.finalizationTimeoutSecs) !==
                message.finalizationTimeoutSecs) {
                throw new globalThis.Error('value provided for field message.finalizationTimeoutSecs of type uint64 too large');
            }
            writer
                .uint32(24)
                .uint64(message.finalizationTimeoutSecs.toString());
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rawTx = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.skipTokenChecks = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.finalizationTimeoutSecs = longToBigint(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rawTx: isSet(object.rawTx)
                ? bytesFromBase64(object.rawTx)
                : new Uint8Array(0),
            skipTokenChecks: isSet(object.skipTokenChecks)
                ? globalThis.Boolean(object.skipTokenChecks)
                : false,
            finalizationTimeoutSecs: isSet(object.finalizationTimeoutSecs)
                ? BigInt(object.finalizationTimeoutSecs)
                : 0n,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rawTx.length !== 0) {
            obj.rawTx = base64FromBytes(message.rawTx);
        }
        if (message.skipTokenChecks !== false) {
            obj.skipTokenChecks = message.skipTokenChecks;
        }
        if (message.finalizationTimeoutSecs !== 0n) {
            obj.finalizationTimeoutSecs =
                message.finalizationTimeoutSecs.toString();
        }
        return obj;
    },
    create(base) {
        return exports.BroadcastTxRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxRequest();
        message.rawTx = object.rawTx ?? new Uint8Array(0);
        message.skipTokenChecks = object.skipTokenChecks ?? false;
        message.finalizationTimeoutSecs = object.finalizationTimeoutSecs ?? 0n;
        return message;
    },
};
function createBaseBroadcastTxResponse() {
    return { txid: new Uint8Array(0) };
}
exports.BroadcastTxResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txid.length !== 0) {
            writer.uint32(10).bytes(message.txid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txid = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txid: isSet(object.txid)
                ? bytesFromBase64(object.txid)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txid.length !== 0) {
            obj.txid = base64FromBytes(message.txid);
        }
        return obj;
    },
    create(base) {
        return exports.BroadcastTxResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxResponse();
        message.txid = object.txid ?? new Uint8Array(0);
        return message;
    },
};
function createBaseBroadcastTxsRequest() {
    return { rawTxs: [], skipTokenChecks: false, finalizationTimeoutSecs: 0n };
}
exports.BroadcastTxsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rawTxs) {
            writer.uint32(10).bytes(v);
        }
        if (message.skipTokenChecks !== false) {
            writer.uint32(16).bool(message.skipTokenChecks);
        }
        if (message.finalizationTimeoutSecs !== 0n) {
            if (BigInt.asUintN(64, message.finalizationTimeoutSecs) !==
                message.finalizationTimeoutSecs) {
                throw new globalThis.Error('value provided for field message.finalizationTimeoutSecs of type uint64 too large');
            }
            writer
                .uint32(24)
                .uint64(message.finalizationTimeoutSecs.toString());
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rawTxs.push(reader.bytes());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.skipTokenChecks = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.finalizationTimeoutSecs = longToBigint(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rawTxs: globalThis.Array.isArray(object?.rawTxs)
                ? object.rawTxs.map((e) => bytesFromBase64(e))
                : [],
            skipTokenChecks: isSet(object.skipTokenChecks)
                ? globalThis.Boolean(object.skipTokenChecks)
                : false,
            finalizationTimeoutSecs: isSet(object.finalizationTimeoutSecs)
                ? BigInt(object.finalizationTimeoutSecs)
                : 0n,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rawTxs?.length) {
            obj.rawTxs = message.rawTxs.map(e => base64FromBytes(e));
        }
        if (message.skipTokenChecks !== false) {
            obj.skipTokenChecks = message.skipTokenChecks;
        }
        if (message.finalizationTimeoutSecs !== 0n) {
            obj.finalizationTimeoutSecs =
                message.finalizationTimeoutSecs.toString();
        }
        return obj;
    },
    create(base) {
        return exports.BroadcastTxsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxsRequest();
        message.rawTxs = object.rawTxs?.map(e => e) || [];
        message.skipTokenChecks = object.skipTokenChecks ?? false;
        message.finalizationTimeoutSecs = object.finalizationTimeoutSecs ?? 0n;
        return message;
    },
};
function createBaseBroadcastTxsResponse() {
    return { txids: [] };
}
exports.BroadcastTxsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.txids) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txids.push(reader.bytes());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txids: globalThis.Array.isArray(object?.txids)
                ? object.txids.map((e) => bytesFromBase64(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txids?.length) {
            obj.txids = message.txids.map(e => base64FromBytes(e));
        }
        return obj;
    },
    create(base) {
        return exports.BroadcastTxsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxsResponse();
        message.txids = object.txids?.map(e => e) || [];
        return message;
    },
};
function createBaseRawTx() {
    return { rawTx: new Uint8Array(0) };
}
exports.RawTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rawTx.length !== 0) {
            writer.uint32(10).bytes(message.rawTx);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRawTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rawTx = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rawTx: isSet(object.rawTx)
                ? bytesFromBase64(object.rawTx)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rawTx.length !== 0) {
            obj.rawTx = base64FromBytes(message.rawTx);
        }
        return obj;
    },
    create(base) {
        return exports.RawTx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRawTx();
        message.rawTx = object.rawTx ?? new Uint8Array(0);
        return message;
    },
};
function createBaseWsSub() {
    return {
        isUnsub: false,
        blocks: undefined,
        txs: undefined,
        script: undefined,
        tokenId: undefined,
        lokadId: undefined,
        plugin: undefined,
        txid: undefined,
    };
}
exports.WsSub = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isUnsub !== false) {
            writer.uint32(8).bool(message.isUnsub);
        }
        if (message.blocks !== undefined) {
            exports.WsSubBlocks.encode(message.blocks, writer.uint32(18).fork()).ldelim();
        }
        if (message.txs !== undefined) {
            exports.WsSubTxs.encode(message.txs, writer.uint32(66).fork()).ldelim();
        }
        if (message.script !== undefined) {
            exports.WsSubScript.encode(message.script, writer.uint32(26).fork()).ldelim();
        }
        if (message.tokenId !== undefined) {
            exports.WsSubTokenId.encode(message.tokenId, writer.uint32(34).fork()).ldelim();
        }
        if (message.lokadId !== undefined) {
            exports.WsSubLokadId.encode(message.lokadId, writer.uint32(42).fork()).ldelim();
        }
        if (message.plugin !== undefined) {
            exports.WsPlugin.encode(message.plugin, writer.uint32(50).fork()).ldelim();
        }
        if (message.txid !== undefined) {
            exports.WsSubTxId.encode(message.txid, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSub();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isUnsub = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.blocks = exports.WsSubBlocks.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.txs = exports.WsSubTxs.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.script = exports.WsSubScript.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.tokenId = exports.WsSubTokenId.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.lokadId = exports.WsSubLokadId.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.plugin = exports.WsPlugin.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.txid = exports.WsSubTxId.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isUnsub: isSet(object.isUnsub)
                ? globalThis.Boolean(object.isUnsub)
                : false,
            blocks: isSet(object.blocks)
                ? exports.WsSubBlocks.fromJSON(object.blocks)
                : undefined,
            txs: isSet(object.txs) ? exports.WsSubTxs.fromJSON(object.txs) : undefined,
            script: isSet(object.script)
                ? exports.WsSubScript.fromJSON(object.script)
                : undefined,
            tokenId: isSet(object.tokenId)
                ? exports.WsSubTokenId.fromJSON(object.tokenId)
                : undefined,
            lokadId: isSet(object.lokadId)
                ? exports.WsSubLokadId.fromJSON(object.lokadId)
                : undefined,
            plugin: isSet(object.plugin)
                ? exports.WsPlugin.fromJSON(object.plugin)
                : undefined,
            txid: isSet(object.txid)
                ? exports.WsSubTxId.fromJSON(object.txid)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isUnsub !== false) {
            obj.isUnsub = message.isUnsub;
        }
        if (message.blocks !== undefined) {
            obj.blocks = exports.WsSubBlocks.toJSON(message.blocks);
        }
        if (message.txs !== undefined) {
            obj.txs = exports.WsSubTxs.toJSON(message.txs);
        }
        if (message.script !== undefined) {
            obj.script = exports.WsSubScript.toJSON(message.script);
        }
        if (message.tokenId !== undefined) {
            obj.tokenId = exports.WsSubTokenId.toJSON(message.tokenId);
        }
        if (message.lokadId !== undefined) {
            obj.lokadId = exports.WsSubLokadId.toJSON(message.lokadId);
        }
        if (message.plugin !== undefined) {
            obj.plugin = exports.WsPlugin.toJSON(message.plugin);
        }
        if (message.txid !== undefined) {
            obj.txid = exports.WsSubTxId.toJSON(message.txid);
        }
        return obj;
    },
    create(base) {
        return exports.WsSub.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsSub();
        message.isUnsub = object.isUnsub ?? false;
        message.blocks =
            object.blocks !== undefined && object.blocks !== null
                ? exports.WsSubBlocks.fromPartial(object.blocks)
                : undefined;
        message.txs =
            object.txs !== undefined && object.txs !== null
                ? exports.WsSubTxs.fromPartial(object.txs)
                : undefined;
        message.script =
            object.script !== undefined && object.script !== null
                ? exports.WsSubScript.fromPartial(object.script)
                : undefined;
        message.tokenId =
            object.tokenId !== undefined && object.tokenId !== null
                ? exports.WsSubTokenId.fromPartial(object.tokenId)
                : undefined;
        message.lokadId =
            object.lokadId !== undefined && object.lokadId !== null
                ? exports.WsSubLokadId.fromPartial(object.lokadId)
                : undefined;
        message.plugin =
            object.plugin !== undefined && object.plugin !== null
                ? exports.WsPlugin.fromPartial(object.plugin)
                : undefined;
        message.txid =
            object.txid !== undefined && object.txid !== null
                ? exports.WsSubTxId.fromPartial(object.txid)
                : undefined;
        return message;
    },
};
function createBaseWsSubBlocks() {
    return {};
}
exports.WsSubBlocks = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSubBlocks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.WsSubBlocks.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseWsSubBlocks();
        return message;
    },
};
function createBaseWsSubTxs() {
    return {};
}
exports.WsSubTxs = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSubTxs();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.WsSubTxs.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseWsSubTxs();
        return message;
    },
};
function createBaseWsSubScript() {
    return { scriptType: '', payload: new Uint8Array(0) };
}
exports.WsSubScript = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.scriptType !== '') {
            writer.uint32(10).string(message.scriptType);
        }
        if (message.payload.length !== 0) {
            writer.uint32(18).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSubScript();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.scriptType = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            scriptType: isSet(object.scriptType)
                ? globalThis.String(object.scriptType)
                : '',
            payload: isSet(object.payload)
                ? bytesFromBase64(object.payload)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.scriptType !== '') {
            obj.scriptType = message.scriptType;
        }
        if (message.payload.length !== 0) {
            obj.payload = base64FromBytes(message.payload);
        }
        return obj;
    },
    create(base) {
        return exports.WsSubScript.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsSubScript();
        message.scriptType = object.scriptType ?? '';
        message.payload = object.payload ?? new Uint8Array(0);
        return message;
    },
};
function createBaseWsSubTokenId() {
    return { tokenId: '' };
}
exports.WsSubTokenId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenId !== '') {
            writer.uint32(10).string(message.tokenId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSubTokenId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tokenId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tokenId: isSet(object.tokenId)
                ? globalThis.String(object.tokenId)
                : '',
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenId !== '') {
            obj.tokenId = message.tokenId;
        }
        return obj;
    },
    create(base) {
        return exports.WsSubTokenId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsSubTokenId();
        message.tokenId = object.tokenId ?? '';
        return message;
    },
};
function createBaseWsSubLokadId() {
    return { lokadId: new Uint8Array(0) };
}
exports.WsSubLokadId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lokadId.length !== 0) {
            writer.uint32(10).bytes(message.lokadId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSubLokadId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.lokadId = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            lokadId: isSet(object.lokadId)
                ? bytesFromBase64(object.lokadId)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.lokadId.length !== 0) {
            obj.lokadId = base64FromBytes(message.lokadId);
        }
        return obj;
    },
    create(base) {
        return exports.WsSubLokadId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsSubLokadId();
        message.lokadId = object.lokadId ?? new Uint8Array(0);
        return message;
    },
};
function createBaseWsPlugin() {
    return { pluginName: '', group: new Uint8Array(0) };
}
exports.WsPlugin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pluginName !== '') {
            writer.uint32(10).string(message.pluginName);
        }
        if (message.group.length !== 0) {
            writer.uint32(18).bytes(message.group);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsPlugin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pluginName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.group = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pluginName: isSet(object.pluginName)
                ? globalThis.String(object.pluginName)
                : '',
            group: isSet(object.group)
                ? bytesFromBase64(object.group)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pluginName !== '') {
            obj.pluginName = message.pluginName;
        }
        if (message.group.length !== 0) {
            obj.group = base64FromBytes(message.group);
        }
        return obj;
    },
    create(base) {
        return exports.WsPlugin.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsPlugin();
        message.pluginName = object.pluginName ?? '';
        message.group = object.group ?? new Uint8Array(0);
        return message;
    },
};
function createBaseWsSubTxId() {
    return { txid: '' };
}
exports.WsSubTxId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txid !== '') {
            writer.uint32(10).string(message.txid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsSubTxId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txid = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txid: isSet(object.txid) ? globalThis.String(object.txid) : '',
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txid !== '') {
            obj.txid = message.txid;
        }
        return obj;
    },
    create(base) {
        return exports.WsSubTxId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsSubTxId();
        message.txid = object.txid ?? '';
        return message;
    },
};
function createBaseWsMsg() {
    return { error: undefined, block: undefined, tx: undefined };
}
exports.WsMsg = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.error !== undefined) {
            exports.Error.encode(message.error, writer.uint32(10).fork()).ldelim();
        }
        if (message.block !== undefined) {
            exports.MsgBlock.encode(message.block, writer.uint32(18).fork()).ldelim();
        }
        if (message.tx !== undefined) {
            exports.MsgTx.encode(message.tx, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWsMsg();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.error = exports.Error.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.block = exports.MsgBlock.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.tx = exports.MsgTx.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            error: isSet(object.error)
                ? exports.Error.fromJSON(object.error)
                : undefined,
            block: isSet(object.block)
                ? exports.MsgBlock.fromJSON(object.block)
                : undefined,
            tx: isSet(object.tx) ? exports.MsgTx.fromJSON(object.tx) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.error !== undefined) {
            obj.error = exports.Error.toJSON(message.error);
        }
        if (message.block !== undefined) {
            obj.block = exports.MsgBlock.toJSON(message.block);
        }
        if (message.tx !== undefined) {
            obj.tx = exports.MsgTx.toJSON(message.tx);
        }
        return obj;
    },
    create(base) {
        return exports.WsMsg.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWsMsg();
        message.error =
            object.error !== undefined && object.error !== null
                ? exports.Error.fromPartial(object.error)
                : undefined;
        message.block =
            object.block !== undefined && object.block !== null
                ? exports.MsgBlock.fromPartial(object.block)
                : undefined;
        message.tx =
            object.tx !== undefined && object.tx !== null
                ? exports.MsgTx.fromPartial(object.tx)
                : undefined;
        return message;
    },
};
function createBaseCoinbaseData() {
    return { coinbaseScriptsig: new Uint8Array(0), coinbaseOutputs: [] };
}
exports.CoinbaseData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.coinbaseScriptsig.length !== 0) {
            writer.uint32(10).bytes(message.coinbaseScriptsig);
        }
        for (const v of message.coinbaseOutputs) {
            exports.TxOutput.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCoinbaseData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.coinbaseScriptsig = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.coinbaseOutputs.push(exports.TxOutput.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            coinbaseScriptsig: isSet(object.coinbaseScriptsig)
                ? bytesFromBase64(object.coinbaseScriptsig)
                : new Uint8Array(0),
            coinbaseOutputs: globalThis.Array.isArray(object?.coinbaseOutputs)
                ? object.coinbaseOutputs.map((e) => exports.TxOutput.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.coinbaseScriptsig.length !== 0) {
            obj.coinbaseScriptsig = base64FromBytes(message.coinbaseScriptsig);
        }
        if (message.coinbaseOutputs?.length) {
            obj.coinbaseOutputs = message.coinbaseOutputs.map(e => exports.TxOutput.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CoinbaseData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCoinbaseData();
        message.coinbaseScriptsig =
            object.coinbaseScriptsig ?? new Uint8Array(0);
        message.coinbaseOutputs =
            object.coinbaseOutputs?.map(e => exports.TxOutput.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgBlock() {
    return {
        msgType: 0,
        blockHash: new Uint8Array(0),
        blockHeight: 0,
        blockTimestamp: 0n,
        coinbaseData: undefined,
    };
}
exports.MsgBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.msgType !== 0) {
            writer.uint32(8).int32(message.msgType);
        }
        if (message.blockHash.length !== 0) {
            writer.uint32(18).bytes(message.blockHash);
        }
        if (message.blockHeight !== 0) {
            writer.uint32(24).int32(message.blockHeight);
        }
        if (message.blockTimestamp !== 0n) {
            if (BigInt.asIntN(64, message.blockTimestamp) !==
                message.blockTimestamp) {
                throw new globalThis.Error('value provided for field message.blockTimestamp of type int64 too large');
            }
            writer.uint32(32).int64(message.blockTimestamp.toString());
        }
        if (message.coinbaseData !== undefined) {
            exports.CoinbaseData.encode(message.coinbaseData, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.msgType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.blockHash = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.blockHeight = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.blockTimestamp = longToBigint(reader.int64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.coinbaseData = exports.CoinbaseData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgType: isSet(object.msgType)
                ? blockMsgTypeFromJSON(object.msgType)
                : 0,
            blockHash: isSet(object.blockHash)
                ? bytesFromBase64(object.blockHash)
                : new Uint8Array(0),
            blockHeight: isSet(object.blockHeight)
                ? globalThis.Number(object.blockHeight)
                : 0,
            blockTimestamp: isSet(object.blockTimestamp)
                ? BigInt(object.blockTimestamp)
                : 0n,
            coinbaseData: isSet(object.coinbaseData)
                ? exports.CoinbaseData.fromJSON(object.coinbaseData)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.msgType !== 0) {
            obj.msgType = blockMsgTypeToJSON(message.msgType);
        }
        if (message.blockHash.length !== 0) {
            obj.blockHash = base64FromBytes(message.blockHash);
        }
        if (message.blockHeight !== 0) {
            obj.blockHeight = Math.round(message.blockHeight);
        }
        if (message.blockTimestamp !== 0n) {
            obj.blockTimestamp = message.blockTimestamp.toString();
        }
        if (message.coinbaseData !== undefined) {
            obj.coinbaseData = exports.CoinbaseData.toJSON(message.coinbaseData);
        }
        return obj;
    },
    create(base) {
        return exports.MsgBlock.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgBlock();
        message.msgType = object.msgType ?? 0;
        message.blockHash = object.blockHash ?? new Uint8Array(0);
        message.blockHeight = object.blockHeight ?? 0;
        message.blockTimestamp = object.blockTimestamp ?? 0n;
        message.coinbaseData =
            object.coinbaseData !== undefined && object.coinbaseData !== null
                ? exports.CoinbaseData.fromPartial(object.coinbaseData)
                : undefined;
        return message;
    },
};
function createBaseTxFinalizationReason() {
    return { finalizationType: 0 };
}
exports.TxFinalizationReason = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.finalizationType !== 0) {
            writer.uint32(8).int32(message.finalizationType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxFinalizationReason();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.finalizationType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            finalizationType: isSet(object.finalizationType)
                ? txFinalizationReasonTypeFromJSON(object.finalizationType)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.finalizationType !== 0) {
            obj.finalizationType = txFinalizationReasonTypeToJSON(message.finalizationType);
        }
        return obj;
    },
    create(base) {
        return exports.TxFinalizationReason.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTxFinalizationReason();
        message.finalizationType = object.finalizationType ?? 0;
        return message;
    },
};
function createBaseMsgTx() {
    return {
        msgType: 0,
        txid: new Uint8Array(0),
        finalizationReason: undefined,
    };
}
exports.MsgTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.msgType !== 0) {
            writer.uint32(8).int32(message.msgType);
        }
        if (message.txid.length !== 0) {
            writer.uint32(18).bytes(message.txid);
        }
        if (message.finalizationReason !== undefined) {
            exports.TxFinalizationReason.encode(message.finalizationReason, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.msgType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.txid = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.finalizationReason = exports.TxFinalizationReason.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgType: isSet(object.msgType)
                ? txMsgTypeFromJSON(object.msgType)
                : 0,
            txid: isSet(object.txid)
                ? bytesFromBase64(object.txid)
                : new Uint8Array(0),
            finalizationReason: isSet(object.finalizationReason)
                ? exports.TxFinalizationReason.fromJSON(object.finalizationReason)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.msgType !== 0) {
            obj.msgType = txMsgTypeToJSON(message.msgType);
        }
        if (message.txid.length !== 0) {
            obj.txid = base64FromBytes(message.txid);
        }
        if (message.finalizationReason !== undefined) {
            obj.finalizationReason = exports.TxFinalizationReason.toJSON(message.finalizationReason);
        }
        return obj;
    },
    create(base) {
        return exports.MsgTx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgTx();
        message.msgType = object.msgType ?? 0;
        message.txid = object.txid ?? new Uint8Array(0);
        message.finalizationReason =
            object.finalizationReason !== undefined &&
                object.finalizationReason !== null
                ? exports.TxFinalizationReason.fromPartial(object.finalizationReason)
                : undefined;
        return message;
    },
};
function createBaseEmpty() {
    return {};
}
exports.Empty = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEmpty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.Empty.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEmpty();
        return message;
    },
};
function createBaseError() {
    return { msg: '' };
}
exports.Error = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.msg !== '') {
            writer.uint32(18).string(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.msg = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? globalThis.String(object.msg) : '' };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== '') {
            obj.msg = message.msg;
        }
        return obj;
    },
    create(base) {
        return exports.Error.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseError();
        message.msg = object.msg ?? '';
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString('base64');
    }
    else {
        const bin = [];
        arr.forEach(byte => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(''));
    }
}
function longToBigint(long) {
    return BigInt(long.toString());
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=chronik.js.map